{
  "level": "eb01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb01",
    "objects": "AREAS.E3:eb01.e3",
    "mesh": "TREES.E3:eb01.e3"
  },
  "spawn_point": {
    "position": [
      1729.096859289847,
      1414.6784731968087,
      104.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1729.096859289847,
      1514.6784731968087,
      104.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1300.0,
      810.0,
      80.0
    ],
    "bbox_max": [
      1990.0,
      1972.6712646484375,
      240.0
    ],
    "vertex_count": 906,
    "vertices": [
      [
        1615.0,
        960.0,
        100.0
      ],
      [
        1615.0,
        940.0,
        100.0
      ],
      [
        1615.0,
        920.0,
        100.0
      ],
      [
        1615.0,
        840.0,
        100.0
      ],
      [
        1615.0,
        1120.0,
        100.0
      ],
      [
        1300.0,
        1130.0,
        100.0
      ],
      [
        1615.0,
        1130.0,
        100.0
      ],
      [
        1615.0,
        960.0,
        100.0
      ],
      [
        1615.0,
        960.0,
        98.0
      ],
      [
        1615.0,
        920.0,
        80.0
      ],
      [
        1615.0,
        920.0,
        100.0
      ],
      [
        1615.0,
        1110.0,
        120.0
      ],
      [
        1615.0,
        1120.0,
        100.0
      ],
      [
        1615.0,
        810.0,
        120.0
      ],
      [
        1615.0,
        810.0,
        140.0
      ],
      [
        1615.0,
        810.0,
        240.0
      ],
      [
        1615.0,
        810.0,
        100.0
      ],
      [
        1615.0,
        840.0,
        120.0
      ],
      [
        1615.0,
        840.0,
        100.0
      ],
      [
        1615.0,
        840.0,
        220.0
      ],
      [
        1615.0,
        840.0,
        140.0
      ],
      [
        1615.0,
        840.0,
        120.0
      ],
      [
        1615.0,
        810.0,
        120.0
      ],
      [
        1615.0,
        810.0,
        140.0
      ],
      [
        1615.0,
        840.0,
        140.0
      ],
      [
        1615.0,
        870.0,
        215.0
      ],
      [
        1615.0,
        870.0,
        220.0
      ],
      [
        1615.0,
        860.0,
        215.0
      ],
      [
        1615.0,
        870.0,
        215.0
      ],
      [
        1615.0,
        900.0,
        220.0
      ],
      [
        1615.0,
        900.0,
        215.0
      ],
      [
        1615.0,
        890.0,
        215.0
      ],
      [
        1615.0,
        900.0,
        215.0
      ],
      [
        1615.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1400.0,
        138.0
      ],
      [
        1579.9998779296875,
        1399.9998779296875,
        138.0
      ],
      [
        1615.0,
        1400.0,
        140.0
      ],
      [
        1579.9998779296875,
        1399.9998779296875,
        138.0
      ],
      [
        1615.0,
        1400.0,
        138.0
      ],
      [
        1615.0,
        1400.0,
        140.0
      ],
      [
        1615.0,
        1400.0,
        160.0
      ],
      [
        1615.0,
        1400.0,
        120.0
      ],
      [
        1615.0,
        1450.0,
        120.0
      ],
      [
        1615.0,
        1400.0,
        120.0
      ],
      [
        1630.0006103515625,
        810.0,
        120.0
      ],
      [
        1630.0006103515625,
        810.0,
        140.0
      ],
      [
        1630.0006103515625,
        810.0,
        240.0
      ],
      [
        1630.0006103515625,
        810.0,
        100.0
      ],
      [
        1630.00048828125,
        960.0,
        100.0
      ],
      [
        1630.00048828125,
        940.0,
        100.0
      ],
      [
        1630.00048828125,
        920.0,
        100.0
      ],
      [
        1630.0006103515625,
        840.0,
        100.0
      ],
      [
        1630.00048828125,
        920.0,
        80.0
      ],
      [
        1630.00048828125,
        920.0,
        100.0
      ],
      [
        1630.00048828125,
        960.0,
        100.0
      ],
      [
        1630.00048828125,
        960.0,
        98.0
      ],
      [
        1630.0006103515625,
        840.0,
        120.0
      ],
      [
        1630.0006103515625,
        840.0,
        100.0
      ],
      [
        1630.0006103515625,
        840.0,
        220.0
      ],
      [
        1630.0006103515625,
        840.0,
        140.0
      ],
      [
        1630.0006103515625,
        840.0,
        120.0
      ],
      [
        1630.0006103515625,
        810.0,
        120.0
      ],
      [
        1630.0006103515625,
        810.0,
        140.0
      ],
      [
        1630.0006103515625,
        840.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1655.0,
        1170.0,
        100.0
      ],
      [
        1655.0,
        1400.0,
        120.0
      ],
      [
        1655.0,
        1400.0,
        120.0
      ],
      [
        1655.0,
        1450.0,
        120.0
      ],
      [
        1655.0,
        810.0,
        120.0
      ],
      [
        1655.0,
        810.0,
        140.0
      ],
      [
        1655.0,
        810.0,
        240.0
      ],
      [
        1655.0,
        810.0,
        100.0
      ],
      [
        1650.0,
        920.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        120.0
      ],
      [
        1650.0,
        810.0,
        120.0
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1650.0,
        1170.0,
        100.0
      ],
      [
        1650.0,
        940.0,
        100.0
      ],
      [
        1650.0,
        920.0,
        100.0
      ],
      [
        1650.0,
        840.0,
        100.0
      ],
      [
        1650.0,
        920.0,
        80.0
      ],
      [
        1650.0,
        920.0,
        100.0
      ],
      [
        1650.0,
        840.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        100.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        220.0
      ],
      [
        1650.0,
        840.0,
        140.0
      ],
      [
        1650.0,
        810.0,
        140.0
      ],
      [
        1650.0,
        840.0,
        140.0
      ],
      [
        1650.0,
        1200.0,
        138.0
      ],
      [
        1650.0,
        1220.0,
        138.0
      ],
      [
        1650.0,
        1050.0,
        138.0
      ],
      [
        1650.0,
        1030.0,
        138.0
      ],
      [
        1650.0,
        1050.0,
        140.0
      ],
      [
        1650.0,
        1050.0,
        138.0
      ],
      [
        1650.0,
        1220.0,
        140.0
      ],
      [
        1650.0,
        1220.0,
        138.0
      ],
      [
        1650.0,
        1140.0,
        131.33334350585938
      ],
      [
        1650.0,
        1150.0,
        131.33334350585938
      ],
      [
        1650.0,
        1150.0,
        133.33334350585938
      ],
      [
        1650.0,
        1150.0,
        131.33334350585938
      ],
      [
        1655.0,
        840.0,
        120.0
      ],
      [
        1655.0,
        840.0,
        100.0
      ],
      [
        1655.0,
        840.0,
        220.0
      ],
      [
        1655.0,
        840.0,
        140.0
      ],
      [
        1655.0,
        840.0,
        120.0
      ],
      [
        1655.0,
        810.0,
        120.0
      ],
      [
        1655.0,
        810.0,
        140.0
      ],
      [
        1655.0,
        840.0,
        140.0
      ],
      [
        1655.0,
        1120.0,
        100.0
      ],
      [
        1655.0,
        1170.0,
        100.0
      ],
      [
        1655.0,
        920.0,
        100.0
      ],
      [
        1655.0,
        840.0,
        100.0
      ],
      [
        1655.0,
        920.0,
        80.0
      ],
      [
        1655.0,
        920.0,
        100.0
      ],
      [
        1650.0,
        963.0,
        100.0
      ],
      [
        1655.0,
        960.0,
        98.0
      ],
      [
        1655.0,
        963.0,
        100.0
      ],
      [
        1655.0,
        990.0,
        118.0
      ],
      [
        1655.0,
        940.0,
        120.0
      ],
      [
        1655.0,
        920.0,
        120.0
      ],
      [
        1655.0,
        940.0,
        118.0
      ],
      [
        1655.0,
        940.0,
        120.0
      ],
      [
        1655.0,
        1200.0,
        138.0
      ],
      [
        1655.0,
        1220.0,
        138.0
      ],
      [
        1655.0,
        1050.0,
        138.0
      ],
      [
        1655.0,
        1030.0,
        138.0
      ],
      [
        1655.0,
        1050.0,
        140.0
      ],
      [
        1655.0,
        1050.0,
        138.0
      ],
      [
        1655.0,
        1220.0,
        140.0
      ],
      [
        1655.0,
        1220.0,
        138.0
      ],
      [
        1655.0,
        1140.0,
        134.6666717529297
      ],
      [
        1655.0,
        1150.0,
        134.6666717529297
      ],
      [
        1655.0,
        1150.0,
        136.6666717529297
      ],
      [
        1655.0,
        1150.0,
        134.6666717529297
      ],
      [
        1655.0,
        1000.0,
        118.0
      ],
      [
        1655.0,
        1000.0,
        120.0
      ],
      [
        1832.5,
        1964.9998779296875,
        135.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        135.0
      ],
      [
        1827.5,
        1964.9998779296875,
        127.5
      ],
      [
        1832.5,
        1964.9998779296875,
        135.0
      ],
      [
        1832.5,
        1964.9998779296875,
        120.0
      ],
      [
        1827.5,
        1964.9998779296875,
        127.5
      ],
      [
        1852.5,
        1964.9998779296875,
        127.5
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        120.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        135.0
      ],
      [
        1852.5,
        1964.9998779296875,
        127.5
      ],
      [
        1839.0,
        1972.6712646484375,
        123.0
      ],
      [
        1841.0,
        1964.9998779296875,
        123.0
      ],
      [
        1839.0,
        1964.9998779296875,
        123.0
      ],
      [
        1690.0,
        810.0,
        120.0
      ],
      [
        1690.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        810.0,
        240.0
      ],
      [
        1690.0,
        810.0,
        100.0
      ],
      [
        1690.0,
        840.0,
        120.0
      ],
      [
        1690.0,
        840.0,
        100.0
      ],
      [
        1690.0,
        840.0,
        220.0
      ],
      [
        1690.0,
        840.0,
        140.0
      ],
      [
        1690.0,
        840.0,
        120.0
      ],
      [
        1690.0,
        810.0,
        120.0
      ],
      [
        1690.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        840.0,
        140.0
      ],
      [
        1690.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        920.0,
        100.0
      ],
      [
        1690.0,
        840.0,
        100.0
      ],
      [
        1690.0,
        920.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        98.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        920.0,
        120.0
      ],
      [
        1695.0,
        1300.2725830078125,
        140.0
      ],
      [
        1695.0,
        1245.5452880859375,
        160.0
      ],
      [
        1695.0,
        1245.5452880859375,
        160.0
      ],
      [
        1691.018310546875,
        1231.018310546875,
        165.308837890625
      ],
      [
        1875.0,
        1760.0,
        120.0
      ],
      [
        1875.0,
        1780.207275390625,
        120.0
      ],
      [
        1875.0,
        1739.792724609375,
        120.0
      ],
      [
        1875.0,
        1760.0,
        120.0
      ],
      [
        1875.0,
        1713.0384521484375,
        120.0
      ],
      [
        1875.0,
        1739.792724609375,
        120.0
      ],
      [
        1875.0,
        1806.9615478515625,
        120.0
      ],
      [
        1875.0,
        1780.207275390625,
        120.0
      ],
      [
        1875.0,
        1385.59130859375,
        140.0
      ],
      [
        1875.0,
        1780.207275390625,
        163.7836151123047
      ],
      [
        1875.0,
        1760.0,
        164.82962036132812
      ],
      [
        1875.0,
        1806.9615478515625,
        185.0
      ],
      [
        1875.0,
        1780.207275390625,
        188.78363037109375
      ],
      [
        1875.0,
        1806.9615478515625,
        185.0
      ],
      [
        1875.0,
        1814.0325927734375,
        177.5
      ],
      [
        1990.0,
        1815.0,
        139.7664031982422
      ],
      [
        1990.0,
        1810.487060546875,
        140.0
      ],
      [
        1875.0,
        1780.207275390625,
        138.7836151123047
      ],
      [
        1875.0,
        1760.0,
        139.82962036132812
      ],
      [
        1875.0,
        1780.207275390625,
        163.78363037109375
      ],
      [
        1875.0,
        1806.9615478515625,
        160.0
      ],
      [
        1875.0,
        1814.0325927734375,
        152.5
      ],
      [
        1875.0,
        1806.9615478515625,
        145.0
      ],
      [
        1875.0,
        1806.9615478515625,
        160.0
      ],
      [
        1875.0,
        1814.0325927734375,
        152.5
      ],
      [
        1875.0,
        1705.9674072265625,
        152.5
      ],
      [
        1875.0,
        1713.0384521484375,
        145.0
      ],
      [
        1875.0,
        1760.0,
        139.82962036132812
      ],
      [
        1875.0,
        1739.792724609375,
        138.78363037109375
      ],
      [
        1875.0,
        1780.207275390625,
        138.78363037109375
      ],
      [
        1875.0,
        1806.9615478515625,
        135.0
      ],
      [
        1875.0,
        1739.792724609375,
        138.7836151123047
      ],
      [
        1875.0,
        1713.0384521484375,
        135.0
      ],
      [
        1875.0,
        1713.0384521484375,
        135.0
      ],
      [
        1875.0,
        1705.9674072265625,
        127.5
      ],
      [
        1875.0,
        1705.9674072265625,
        127.5
      ],
      [
        1875.0,
        1713.0384521484375,
        120.0
      ],
      [
        1895.310791015625,
        1742.5,
        120.0
      ],
      [
        1875.0,
        1806.9615478515625,
        135.0
      ],
      [
        1875.0,
        1814.0325927734375,
        127.5
      ],
      [
        1875.0,
        1814.0325927734375,
        127.5
      ],
      [
        1875.0,
        1806.9615478515625,
        120.0
      ],
      [
        1895.3109130859375,
        1777.5,
        135.0
      ],
      [
        1690.0,
        1465.0,
        135.0
      ],
      [
        1690.0,
        1442.5,
        135.0
      ],
      [
        1690.0,
        1465.0,
        135.0
      ],
      [
        1690.0,
        1495.0,
        135.0
      ],
      [
        1690.0,
        1495.0,
        135.0
      ],
      [
        1690.0,
        1554.9998779296875,
        135.0
      ],
      [
        1690.0,
        1820.4000244140625,
        165.0
      ],
      [
        1690.0,
        1905.432373046875,
        165.0
      ],
      [
        1690.0,
        1965.0,
        165.0
      ],
      [
        1690.0,
        1905.432373046875,
        165.0
      ],
      [
        1691.25,
        1388.75,
        165.0
      ],
      [
        1690.0,
        1390.0,
        166.6666717529297
      ],
      [
        1690.0,
        1230.0,
        166.6666717529297
      ],
      [
        1691.25,
        1231.8634033203125,
        165.0
      ],
      [
        1690.0,
        1902.57763671875,
        190.0
      ],
      [
        1690.0,
        1965.0,
        190.0
      ],
      [
        1690.0,
        1760.0001220703125,
        190.0
      ],
      [
        1690.0,
        1902.57763671875,
        190.0
      ],
      [
        1770.0,
        1400.0,
        190.0
      ],
      [
        1770.0,
        1406.666748046875,
        190.0
      ],
      [
        1770.0,
        1406.666748046875,
        190.0
      ],
      [
        1770.0,
        1443.333251953125,
        190.0
      ],
      [
        1758.75,
        1388.75,
        165.0
      ],
      [
        1690.0,
        1400.0,
        180.0
      ],
      [
        1690.0,
        1390.0,
        166.6666717529297
      ],
      [
        1691.25,
        1388.75,
        165.0
      ],
      [
        1770.0,
        1400.0,
        180.0
      ],
      [
        1770.0,
        1406.8182373046875,
        189.09097290039062
      ],
      [
        1770.0,
        1406.8182373046875,
        189.09097290039062
      ],
      [
        1770.0,
        1407.5,
        190.0
      ],
      [
        1770.0,
        1400.0,
        165.0
      ],
      [
        1770.0,
        1410.8333740234375,
        165.0
      ],
      [
        1770.0,
        1410.8333740234375,
        165.0
      ],
      [
        1770.0,
        1439.1666259765625,
        165.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        165.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        165.0
      ],
      [
        1727.25,
        1410.0,
        165.0
      ],
      [
        1723.75,
        1410.0,
        165.0
      ],
      [
        1727.25,
        1410.0,
        165.0
      ],
      [
        1727.25,
        1400.0,
        165.0
      ],
      [
        1710.0,
        1965.0,
        140.0
      ],
      [
        1710.0,
        1862.0657958984375,
        140.0
      ],
      [
        1710.0,
        1760.0001220703125,
        140.0
      ],
      [
        1710.0,
        1862.0657958984375,
        140.0
      ],
      [
        1710.0,
        1555.0,
        140.0
      ],
      [
        1710.0,
        1653.634765625,
        140.0
      ],
      [
        1710.0,
        1653.634765625,
        140.0
      ],
      [
        1710.0,
        1760.0001220703125,
        140.0
      ],
      [
        1710.0,
        1385.0,
        140.0
      ],
      [
        1832.5,
        1834.461669921875,
        160.0
      ],
      [
        1847.5001220703125,
        1849.461669921875,
        160.0
      ],
      [
        1770.0,
        1400.0,
        140.0
      ],
      [
        1847.5001220703125,
        1822.009521484375,
        160.0
      ],
      [
        1830.8980712890625,
        1830.0,
        157.5970001220703
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        140.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        140.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        140.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        140.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        140.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        140.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        140.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        140.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        140.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        140.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        140.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      [
        1702.050048828125,
        1410.0,
        150.60000610351562
      ],
      [
        1702.050048828125,
        1400.0,
        150.6000213623047
      ],
      [
        1702.050048828125,
        1410.0,
        150.6000213623047
      ],
      [
        1701.0,
        1410.0,
        151.99998474121094
      ],
      [
        1780.0,
        1864.322998046875,
        135.0
      ],
      [
        1780.0001220703125,
        1965.0001220703125,
        135.0
      ],
      [
        1780.0,
        1555.0,
        135.0
      ],
      [
        1780.0,
        1656.4769287109375,
        135.0
      ],
      [
        1798.469970703125,
        1425.0,
        135.0
      ],
      [
        1804.0340576171875,
        1404.2349853515625,
        135.0
      ],
      [
        1804.0340576171875,
        1404.2349853515625,
        135.0
      ],
      [
        1819.23486328125,
        1389.033935546875,
        135.0
      ],
      [
        1780.0,
        1404.30224609375,
        136.43409729003906
      ],
      [
        1780.0,
        1415.0,
        140.0
      ],
      [
        1780.0,
        1555.0,
        138.0
      ],
      [
        1710.0,
        1554.9998779296875,
        140.0
      ],
      [
        1711.5,
        1554.9998779296875,
        138.0
      ],
      [
        1770.0,
        1400.0,
        138.0
      ],
      [
        1710.0,
        1400.0,
        140.0
      ],
      [
        1711.5,
        1400.0,
        138.0
      ],
      [
        1770.0,
        1400.0,
        138.0
      ],
      [
        1770.0,
        1409.0,
        138.0
      ],
      [
        1770.0,
        1409.0,
        138.0
      ],
      [
        1780.0,
        1409.0,
        138.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        138.0
      ],
      [
        1780.0,
        1864.322998046875,
        138.0
      ],
      [
        1780.0,
        1656.4769287109375,
        138.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        138.0
      ],
      [
        1734.053955078125,
        1812.7999267578125,
        138.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        138.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        138.0
      ],
      [
        1734.053955078125,
        1812.7999267578125,
        138.0
      ],
      [
        1734.0133056640625,
        1708.0499267578125,
        138.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        138.0
      ],
      [
        1734.0133056640625,
        1708.0499267578125,
        138.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        138.0
      ],
      [
        1722.0,
        1760.0,
        138.0
      ],
      [
        1729.9852294921875,
        1790.0,
        138.0
      ],
      [
        1729.8226318359375,
        1731.0,
        138.0
      ],
      [
        1722.0,
        1760.0,
        138.0
      ],
      [
        1750.0,
        1767.5,
        138.0
      ],
      [
        1750.0001220703125,
        1752.5001220703125,
        138.0
      ],
      [
        1750.0001220703125,
        1752.5001220703125,
        138.0
      ],
      [
        1750.0,
        1731.0,
        138.0
      ],
      [
        1750.0,
        1790.0,
        138.0
      ],
      [
        1750.0,
        1767.5,
        138.0
      ],
      [
        1750.0,
        1731.0,
        138.0
      ],
      [
        1729.8226318359375,
        1731.0,
        138.0
      ],
      [
        1729.9852294921875,
        1790.0,
        138.0
      ],
      [
        1750.0,
        1790.0,
        138.0
      ],
      [
        1780.0,
        1555.0,
        135.0
      ],
      [
        1713.75,
        1554.9998779296875,
        135.0
      ],
      [
        1770.0,
        1400.0,
        135.0
      ],
      [
        1713.75,
        1400.0,
        135.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        135.0
      ],
      [
        1780.0,
        1864.322998046875,
        135.0
      ],
      [
        1780.0,
        1656.4769287109375,
        135.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        135.0
      ],
      [
        1731.0196533203125,
        1801.4000244140625,
        135.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        135.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        135.0
      ],
      [
        1731.0196533203125,
        1801.4000244140625,
        135.0
      ],
      [
        1730.91796875,
        1719.52490234375,
        135.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        135.0
      ],
      [
        1730.91796875,
        1719.52490234375,
        135.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        135.0
      ],
      [
        1690.0,
        1965.0,
        140.0
      ],
      [
        1690.0,
        1894.0220947265625,
        140.0
      ],
      [
        1690.0,
        1760.0001220703125,
        140.0
      ],
      [
        1690.0,
        1894.0220947265625,
        140.0
      ],
      [
        1690.0,
        1555.0,
        140.0
      ],
      [
        1690.0,
        1617.767578125,
        140.0
      ],
      [
        1690.0,
        1617.767578125,
        140.0
      ],
      [
        1690.0,
        1760.0001220703125,
        140.0
      ],
      [
        1695.0,
        1410.0,
        146.5714111328125
      ],
      [
        1695.0,
        1400.0,
        146.57142639160156
      ],
      [
        1695.0,
        1410.0,
        146.57142639160156
      ],
      [
        1695.0,
        1410.0,
        148.5714111328125
      ],
      [
        1690.0,
        1410.0,
        143.7142791748047
      ],
      [
        1690.0,
        1400.0,
        143.71429443359375
      ],
      [
        1690.0,
        1410.0,
        143.71429443359375
      ],
      [
        1690.0,
        1410.0,
        145.7142791748047
      ],
      [
        1690.0,
        1400.0,
        140.0
      ],
      [
        1690.0,
        1400.0,
        135.0
      ],
      [
        1690.0,
        1554.9998779296875,
        135.0
      ],
      [
        1690.0,
        1554.9998779296875,
        140.0
      ],
      [
        1701.275390625,
        1540.0,
        135.0
      ],
      [
        1701.2752685546875,
        1534.9998779296875,
        135.0
      ],
      [
        1701.275390625,
        1510.0001220703125,
        135.0
      ],
      [
        1701.275390625,
        1505.0,
        135.0
      ],
      [
        1701.275390625,
        1525.0,
        135.0
      ],
      [
        1701.275390625,
        1520.0,
        135.0
      ],
      [
        1701.275390625,
        1520.0,
        135.0
      ],
      [
        1701.2752685546875,
        1534.9998779296875,
        135.0
      ],
      [
        1701.275390625,
        1540.0,
        135.0
      ],
      [
        1701.275390625,
        1525.0,
        135.0
      ],
      [
        1701.275390625,
        1505.0,
        135.0
      ],
      [
        1701.275390625,
        1510.0001220703125,
        135.0
      ],
      [
        1857.5001220703125,
        1355.0,
        120.0
      ],
      [
        1857.5001220703125,
        1359.68896484375,
        120.0
      ],
      [
        1857.5001220703125,
        1359.68896484375,
        120.0
      ],
      [
        1857.5,
        1385.5709228515625,
        120.0
      ],
      [
        1857.4996337890625,
        1815.31103515625,
        120.0
      ],
      [
        1857.4996337890625,
        1790.310302734375,
        120.0
      ],
      [
        1857.499755859375,
        1729.689697265625,
        120.0
      ],
      [
        1857.499755859375,
        1745.03564453125,
        120.0
      ],
      [
        1857.499755859375,
        1774.96435546875,
        120.0
      ],
      [
        1857.499755859375,
        1790.3104248046875,
        120.0
      ],
      [
        1857.499755859375,
        1704.6890869140625,
        120.0
      ],
      [
        1857.499755859375,
        1729.689697265625,
        120.0
      ],
      [
        1857.499755859375,
        1704.6890869140625,
        120.0
      ],
      [
        1857.4996337890625,
        1815.31103515625,
        120.0
      ],
      [
        1853.499755859375,
        1773.3074951171875,
        126.0
      ],
      [
        1853.4998779296875,
        1746.692626953125,
        126.0
      ],
      [
        1872.070556640625,
        1815.5478515625,
        126.0
      ],
      [
        1873.9937744140625,
        1813.6246337890625,
        126.0
      ],
      [
        1875.0,
        1811.5517578125,
        124.86862182617188
      ],
      [
        1855.499755859375,
        1743.03564453125,
        123.0
      ],
      [
        1853.4998779296875,
        1746.692626953125,
        126.0
      ],
      [
        1857.499755859375,
        1745.03564453125,
        120.0
      ],
      [
        1855.499755859375,
        1743.03564453125,
        123.0
      ],
      [
        1875.0,
        1812.618408203125,
        126.0
      ],
      [
        1872.0704345703125,
        1704.4520263671875,
        126.0
      ],
      [
        1875.0,
        1707.381591796875,
        126.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44656372070312
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        131.50537109375
      ],
      [
        1847.499755859375,
        1761.3760986328125,
        135.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        131.50523376464844
      ],
      [
        1847.4998779296875,
        1751.18701171875,
        135.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44656372070312
      ],
      [
        1847.5,
        1355.0,
        120.0
      ],
      [
        1847.5,
        1357.009521484375,
        120.0
      ],
      [
        1847.5,
        1357.009521484375,
        120.0
      ],
      [
        1847.5,
        1382.8914794921875,
        120.0
      ],
      [
        1847.5,
        1817.9903564453125,
        120.0
      ],
      [
        1847.5,
        1781.7557373046875,
        120.0
      ],
      [
        1847.5,
        1702.0096435546875,
        120.0
      ],
      [
        1847.5,
        1738.2442626953125,
        120.0
      ],
      [
        1851.4998779296875,
        1775.307373046875,
        126.0
      ],
      [
        1851.5,
        1744.6927490234375,
        126.0
      ],
      [
        1853.4998779296875,
        1699.47607421875,
        126.0
      ],
      [
        1851.4998779296875,
        1698.940185546875,
        126.0
      ],
      [
        1851.5,
        1821.0596923828125,
        126.0
      ],
      [
        1853.4998779296875,
        1820.5238037109375,
        126.0
      ],
      [
        1850.6707763671875,
        1741.51806640625,
        124.75614166259766
      ],
      [
        1851.5,
        1744.6927490234375,
        126.0
      ],
      [
        1847.5,
        1738.2442626953125,
        120.0
      ],
      [
        1849.5,
        1738.7801513671875,
        123.0
      ],
      [
        1849.5,
        1738.7801513671875,
        123.0
      ],
      [
        1850.6707763671875,
        1741.51806640625,
        124.75614166259766
      ],
      [
        1832.5,
        1530.0,
        120.0
      ],
      [
        1832.5,
        1530.0,
        120.0
      ],
      [
        1832.4998779296875,
        1528.6776123046875,
        120.0
      ],
      [
        1832.5,
        1526.6776123046875,
        120.0
      ],
      [
        1832.4998779296875,
        1520.1776123046875,
        120.0
      ],
      [
        1832.5001220703125,
        1357.009521484375,
        120.0
      ],
      [
        1832.5001220703125,
        1382.891357421875,
        120.0
      ],
      [
        1832.499755859375,
        1702.0096435546875,
        120.0
      ],
      [
        1832.499755859375,
        1738.2442626953125,
        120.0
      ],
      [
        1832.4996337890625,
        1817.990234375,
        120.0
      ],
      [
        1832.4996337890625,
        1781.755615234375,
        120.0
      ],
      [
        1690.0,
        1450.0,
        120.0
      ],
      [
        1690.0,
        1495.0,
        120.0
      ],
      [
        1690.0,
        1495.0,
        120.0
      ],
      [
        1690.0,
        1554.9998779296875,
        120.0
      ],
      [
        1690.0,
        1400.0,
        120.0
      ],
      [
        1690.0,
        1450.0,
        120.0
      ],
      [
        1690.0,
        1902.57763671875,
        120.0
      ],
      [
        1690.0,
        1965.0,
        120.0
      ],
      [
        1690.0,
        1617.767578125,
        120.0
      ],
      [
        1690.0,
        1555.0,
        120.0
      ],
      [
        1690.0,
        1760.0001220703125,
        120.0
      ],
      [
        1690.0,
        1902.57763671875,
        120.0
      ],
      [
        1690.0,
        1760.0001220703125,
        120.0
      ],
      [
        1690.0,
        1617.767578125,
        120.0
      ],
      [
        1780.0,
        1515.0,
        135.0
      ],
      [
        1780.0,
        1510.0,
        127.5
      ],
      [
        1811.105224609375,
        1397.1636962890625,
        135.0
      ],
      [
        1780.0,
        1510.0,
        127.5
      ],
      [
        1780.0,
        1515.0,
        120.0
      ],
      [
        1780.0,
        1530.0,
        120.0
      ],
      [
        1780.0,
        1535.0,
        127.5
      ],
      [
        1826.6885986328125,
        1538.58203125,
        128.7172393798828
      ],
      [
        1826.2132568359375,
        1536.2867431640625,
        129.4302978515625
      ],
      [
        1826.2132568359375,
        1536.2867431640625,
        129.4302978515625
      ],
      [
        1828.499755859375,
        1744.6929931640625,
        126.0
      ],
      [
        1828.5,
        1775.3072509765625,
        126.0
      ],
      [
        1784.4521484375,
        1727.929443359375,
        126.0
      ],
      [
        1780.0,
        1744.5450439453125,
        126.0
      ],
      [
        1780.0,
        1749.8809814453125,
        123.92837524414062
      ],
      [
        1780.0,
        1752.4998779296875,
        120.0
      ],
      [
        1780.0,
        1749.8809814453125,
        123.92837524414062
      ],
      [
        1780.0,
        1770.118896484375,
        123.9283676147461
      ],
      [
        1780.0,
        1775.4552001953125,
        126.0
      ],
      [
        1784.4520263671875,
        1792.0704345703125,
        126.0
      ],
      [
        1780.0,
        1770.118896484375,
        123.9283676147461
      ],
      [
        1780.0,
        1767.5,
        120.0
      ],
      [
        1828.4998779296875,
        1744.69287109375,
        126.0
      ],
      [
        1829.3292236328125,
        1741.517578125,
        124.7558822631836
      ],
      [
        1829.3292236328125,
        1778.482421875,
        124.7558822631836
      ],
      [
        1828.4998779296875,
        1775.30712890625,
        126.0
      ],
      [
        1832.499755859375,
        1738.2442626953125,
        120.0
      ],
      [
        1830.4998779296875,
        1738.7801513671875,
        123.0
      ],
      [
        1832.4996337890625,
        1781.755615234375,
        120.0
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1830.4998779296875,
        1738.7801513671875,
        123.0
      ],
      [
        1829.329345703125,
        1741.5177001953125,
        124.75595092773438
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1829.3292236328125,
        1778.4822998046875,
        124.75595092773438
      ],
      [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      [
        1780.0,
        1770.118896484375,
        131.07164001464844
      ],
      [
        1780.0,
        1767.5,
        135.0
      ],
      [
        1780.0,
        1770.118896484375,
        131.07164001464844
      ],
      [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      [
        1780.0,
        1740.681396484375,
        127.5
      ],
      [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      [
        1780.0,
        1752.4998779296875,
        135.0
      ],
      [
        1822.4998779296875,
        1704.6890869140625,
        135.0
      ],
      [
        1822.499755859375,
        1815.310791015625,
        135.0
      ],
      [
        1780.0,
        1740.681396484375,
        127.5
      ],
      [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      [
        1780.0,
        1535.0,
        127.5
      ],
      [
        1780.0,
        1530.0,
        135.0
      ],
      [
        1822.5001220703125,
        1531.0355224609375,
        135.0
      ],
      [
        1780.0,
        1521.5,
        120.0
      ],
      [
        1780.0,
        1521.5,
        123.0
      ],
      [
        1830.4998779296875,
        1527.84912109375,
        123.0
      ],
      [
        1830.5,
        1525.8492431640625,
        123.0
      ],
      [
        1780.0,
        1523.5,
        123.0
      ],
      [
        1780.0,
        1521.5,
        123.0
      ],
      [
        1780.0,
        1523.5,
        120.0
      ],
      [
        1780.0,
        1523.5,
        123.0
      ],
      [
        1824.828125,
        1523.4998779296875,
        120.0
      ],
      [
        1824.828125,
        1523.4998779296875,
        123.0
      ],
      [
        1832.4998779296875,
        1528.6776123046875,
        120.0
      ],
      [
        1830.5,
        1527.8492431640625,
        123.0
      ],
      [
        1832.5,
        1526.6776123046875,
        120.0
      ],
      [
        1830.5,
        1525.8492431640625,
        123.0
      ],
      [
        1832.4998779296875,
        1520.1776123046875,
        120.0
      ],
      [
        1827.5,
        1513.1065673828125,
        127.5
      ],
      [
        1827.5,
        1513.1065673828125,
        127.5
      ],
      [
        1822.5001220703125,
        1516.0355224609375,
        135.0
      ],
      [
        1690.0,
        1400.0,
        120.0
      ],
      [
        1740.0,
        1505.0001220703125,
        120.0
      ],
      [
        1727.0,
        1508.3333740234375,
        125.0
      ],
      [
        1712.9998779296875,
        1508.3333740234375,
        125.0
      ],
      [
        1730.0,
        1507.0001220703125,
        123.0
      ],
      [
        1727.0,
        1508.3333740234375,
        125.0
      ],
      [
        1710.0001220703125,
        1507.0001220703125,
        123.0
      ],
      [
        1712.9998779296875,
        1508.3333740234375,
        125.0
      ],
      [
        1710.0001220703125,
        1507.0001220703125,
        123.0
      ],
      [
        1730.0,
        1507.0001220703125,
        123.0
      ],
      [
        1721.0,
        1510.5,
        128.24989318847656
      ],
      [
        1719.0,
        1510.5,
        128.24989318847656
      ],
      [
        1721.0001220703125,
        1510.0001220703125,
        127.50012969970703
      ],
      [
        1719.0,
        1510.0,
        127.49990844726562
      ],
      [
        1719.0,
        1510.5,
        128.24989318847656
      ],
      [
        1719.0,
        1510.0,
        127.49990844726562
      ],
      [
        1721.0001220703125,
        1510.0001220703125,
        127.50012969970703
      ],
      [
        1721.0,
        1510.5,
        128.24989318847656
      ],
      [
        1719.9998779296875,
        1513.0001220703125,
        132.0
      ],
      [
        1719.9998779296875,
        1510.4998779296875,
        128.2496795654297
      ],
      [
        1719.9998779296875,
        1510.4998779296875,
        128.2496795654297
      ],
      [
        1719.9998779296875,
        1513.0001220703125,
        132.0
      ],
      [
        1722.0,
        1511.6666259765625,
        125.0
      ],
      [
        1718.0001220703125,
        1511.6666259765625,
        125.0
      ],
      [
        1715.0,
        1512.9998779296875,
        123.0
      ],
      [
        1715.0,
        1514.9998779296875,
        120.0
      ],
      [
        1725.0,
        1514.9998779296875,
        120.0
      ],
      [
        1725.0,
        1512.9998779296875,
        123.0
      ],
      [
        1715.0,
        1512.9998779296875,
        123.0
      ],
      [
        1718.0001220703125,
        1511.6666259765625,
        125.0
      ],
      [
        1725.0,
        1512.9998779296875,
        123.0
      ],
      [
        1722.0,
        1511.6666259765625,
        125.0
      ],
      [
        1721.0,
        1510.5,
        126.74993896484375
      ],
      [
        1719.0,
        1510.5,
        126.74993896484375
      ],
      [
        1721.0,
        1510.5,
        126.74993896484375
      ],
      [
        1719.0,
        1510.5,
        126.74993896484375
      ],
      [
        1719.9998779296875,
        1511.6666259765625,
        125.0
      ],
      [
        1719.9998779296875,
        1510.4998779296875,
        126.75016784667969
      ],
      [
        1719.9998779296875,
        1510.4998779296875,
        126.75016784667969
      ],
      [
        1719.9998779296875,
        1511.6666259765625,
        125.0
      ],
      [
        1740.0,
        1540.0,
        120.0
      ],
      [
        1727.0,
        1536.6666259765625,
        125.0
      ],
      [
        1712.9998779296875,
        1536.66650390625,
        125.0
      ],
      [
        1730.0001220703125,
        1538.0,
        123.0
      ],
      [
        1727.0,
        1536.6666259765625,
        125.0
      ],
      [
        1709.9998779296875,
        1538.0001220703125,
        123.0
      ],
      [
        1712.9998779296875,
        1536.66650390625,
        125.0
      ],
      [
        1730.0001220703125,
        1538.0,
        123.0
      ],
      [
        1709.9998779296875,
        1538.0001220703125,
        123.0
      ],
      [
        1719.0,
        1535.0,
        127.49992370605469
      ],
      [
        1721.0,
        1535.0,
        127.49992370605469
      ],
      [
        1719.0,
        1535.5,
        126.74993896484375
      ],
      [
        1720.9998779296875,
        1535.4998779296875,
        126.75015258789062
      ],
      [
        1719.0,
        1535.5,
        126.74993896484375
      ],
      [
        1719.0,
        1535.0,
        127.49992370605469
      ],
      [
        1721.0,
        1535.0,
        127.49992370605469
      ],
      [
        1720.9998779296875,
        1535.4998779296875,
        126.75015258789062
      ],
      [
        1720.0,
        1535.0,
        127.49992370605469
      ],
      [
        1720.0,
        1531.9998779296875,
        132.0
      ],
      [
        1720.0,
        1531.9998779296875,
        132.0
      ],
      [
        1720.0,
        1535.0,
        127.49992370605469
      ],
      [
        1722.0001220703125,
        1533.33349609375,
        125.0
      ],
      [
        1717.9998779296875,
        1533.33349609375,
        125.0
      ],
      [
        1725.0001220703125,
        1530.0,
        120.0
      ],
      [
        1725.0001220703125,
        1532.0,
        123.0
      ],
      [
        1714.9998779296875,
        1532.0001220703125,
        123.0
      ],
      [
        1714.9998779296875,
        1530.0001220703125,
        120.0
      ],
      [
        1725.0001220703125,
        1532.0,
        123.0
      ],
      [
        1722.0001220703125,
        1533.33349609375,
        125.0
      ],
      [
        1714.9998779296875,
        1532.0001220703125,
        123.0
      ],
      [
        1717.9998779296875,
        1533.33349609375,
        125.0
      ],
      [
        1720.0,
        1533.33349609375,
        125.0
      ],
      [
        1720.0,
        1533.33349609375,
        125.0
      ],
      [
        1725.0,
        1523.5,
        120.0
      ],
      [
        1725.0,
        1521.5,
        120.0
      ],
      [
        1725.0,
        1521.5,
        123.0
      ],
      [
        1725.0,
        1523.5,
        123.0
      ],
      [
        1715.0,
        1523.5,
        123.0
      ],
      [
        1715.0,
        1521.5,
        123.0
      ],
      [
        1715.0,
        1521.5,
        120.0
      ],
      [
        1715.0,
        1523.5,
        120.0
      ],
      [
        1719.9998779296875,
        1510.5,
        128.24989318847656
      ],
      [
        1719.9998779296875,
        1510.5,
        126.74993896484375
      ],
      [
        1780.0,
        1769.5,
        123.0
      ],
      [
        1750.0,
        1769.5,
        123.0
      ],
      [
        1750.0,
        1790.0,
        123.0
      ],
      [
        1750.0,
        1769.5,
        123.0
      ],
      [
        1780.0,
        1750.4998779296875,
        123.0
      ],
      [
        1750.0001220703125,
        1750.5001220703125,
        123.0
      ],
      [
        1750.0001220703125,
        1750.5001220703125,
        123.0
      ],
      [
        1750.0,
        1731.0,
        123.0
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        132.0
      ],
      [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1730.6318359375,
        1728.0,
        124.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        130.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        130.0
      ],
      [
        1730.6318359375,
        1728.0,
        124.0
      ],
      [
        1750.0,
        1775.4998779296875,
        123.0
      ],
      [
        1780.0,
        1773.90185546875,
        125.39698791503906
      ],
      [
        1750.0001220703125,
        1744.5001220703125,
        123.0
      ],
      [
        1780.0,
        1746.09814453125,
        125.39702606201172
      ],
      [
        1832.5001220703125,
        1520.177734375,
        135.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        131.50572204589844
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1832.5,
        1761.3763427734375,
        135.0
      ],
      [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44696044921875
      ],
      [
        1832.4998779296875,
        1758.62353515625,
        135.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        131.50572204589844
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1832.4998779296875,
        1751.18701171875,
        135.0
      ],
      [
        1839.0,
        1537.671630859375,
        120.0
      ],
      [
        1839.0,
        1537.671630859375,
        123.0
      ],
      [
        1839.0,
        1783.4974365234375,
        120.0
      ],
      [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      [
        1839.0,
        1736.5025634765625,
        120.0
      ],
      [
        1839.0,
        1736.5025634765625,
        123.0
      ],
      [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      [
        1841.0,
        1736.5025634765625,
        123.0
      ],
      [
        1840.859619140625,
        1521.640380859375,
        123.0
      ],
      [
        1841.0,
        1526.8076171875,
        120.0
      ],
      [
        1841.0,
        1521.979248046875,
        123.0
      ],
      [
        1839.0,
        1522.8701171875,
        120.0
      ],
      [
        1840.859619140625,
        1521.640380859375,
        123.0
      ],
      [
        1839.0,
        1520.8701171875,
        123.0
      ],
      [
        1830.4998779296875,
        1517.3492431640625,
        123.0
      ],
      [
        1832.4349365234375,
        1526.650634765625,
        120.09761047363281
      ],
      [
        1832.43505859375,
        1526.6507568359375,
        123.0
      ],
      [
        1849.5,
        1542.5,
        123.0
      ],
      [
        1842.2738037109375,
        1520.2261962890625,
        126.0
      ],
      [
        1851.5,
        1542.4998779296875,
        126.0
      ],
      [
        1842.2738037109375,
        1520.2261962890625,
        126.0
      ],
      [
        1828.5,
        1514.520751953125,
        126.0
      ],
      [
        1680.0001220703125,
        1910.0,
        164.34780883789062
      ],
      [
        1680.0001220703125,
        1900.0001220703125,
        163.478271484375
      ],
      [
        1680.0,
        1620.0,
        139.13043212890625
      ],
      [
        1680.0,
        1610.0,
        138.2608642578125
      ],
      [
        1680.0001220703125,
        1917.5001220703125,
        165.0
      ],
      [
        1680.0,
        1965.0,
        169.13043212890625
      ],
      [
        1680.0,
        1200.0,
        102.60868835449219
      ],
      [
        1680.0,
        1450.0,
        120.0
      ],
      [
        1680.0,
        1495.0,
        120.0
      ],
      [
        1680.0,
        1495.0,
        120.0
      ],
      [
        1680.0,
        1554.9998779296875,
        120.0
      ],
      [
        1680.0,
        1450.0,
        120.0
      ],
      [
        1680.0,
        1920.41259765625,
        120.0
      ],
      [
        1680.0,
        1965.0,
        120.0
      ],
      [
        1680.0,
        1599.833984375,
        120.0
      ],
      [
        1680.0,
        1555.0,
        120.0
      ],
      [
        1680.0,
        1760.0001220703125,
        120.0
      ],
      [
        1680.0,
        1920.41259765625,
        120.0
      ],
      [
        1680.0,
        1760.0001220703125,
        120.0
      ],
      [
        1680.0,
        1599.833984375,
        120.0
      ],
      [
        1682.391357421875,
        995.0,
        84.78260803222656
      ],
      [
        1680.0,
        1060.4761962890625,
        90.47618865966797
      ],
      [
        1680.0,
        1760.0001220703125,
        140.0
      ],
      [
        1690.0,
        1630.0,
        140.0
      ],
      [
        1680.0,
        1760.0001220703125,
        140.0
      ],
      [
        1680.0,
        1630.0,
        140.0
      ],
      [
        1680.0001220703125,
        1917.5001220703125,
        165.0
      ],
      [
        1690.0,
        1917.5001220703125,
        165.0
      ],
      [
        1690.0,
        1910.0,
        164.34780883789062
      ],
      [
        1680.0001220703125,
        1910.0,
        164.34780883789062
      ],
      [
        1680.0,
        1620.0,
        139.13043212890625
      ],
      [
        1690.0,
        1620.0,
        139.13043212890625
      ],
      [
        1680.0,
        1610.0,
        138.26087951660156
      ],
      [
        1690.0,
        1610.0,
        138.2608642578125
      ],
      [
        1655.0,
        1630.0,
        140.0
      ],
      [
        1665.0,
        1910.916015625,
        164.42747497558594
      ],
      [
        1655.0,
        1910.916015625,
        164.42747497558594
      ],
      [
        1665.0,
        1917.93896484375,
        165.0381622314453
      ],
      [
        1665.0,
        1910.916015625,
        164.42747497558594
      ],
      [
        1655.0,
        1918.0,
        140.0
      ],
      [
        1665.0,
        1918.0,
        140.0
      ],
      [
        1665.0,
        1918.0,
        140.0
      ],
      [
        1680.0,
        1920.41259765625,
        190.0
      ],
      [
        1680.0,
        1965.0,
        190.0
      ],
      [
        1680.0,
        1760.0001220703125,
        190.0
      ],
      [
        1680.0,
        1920.41259765625,
        190.0
      ],
      [
        1680.0,
        810.0,
        240.0
      ],
      [
        1680.0,
        810.0,
        190.0
      ],
      [
        1690.0,
        810.0,
        190.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        840.0,
        190.0
      ],
      [
        1690.0,
        840.0,
        190.0
      ],
      [
        1680.0,
        840.0,
        180.0
      ],
      [
        1690.0,
        840.0,
        166.66665649414062
      ],
      [
        1680.0,
        810.0,
        180.0
      ],
      [
        1690.0,
        810.0,
        166.66665649414062
      ],
      [
        1680.0001220703125,
        1910.0,
        179.9998016357422
      ],
      [
        1687.5,
        1910.0,
        170.0
      ],
      [
        1680.0,
        1820.4000244140625,
        165.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1442.5,
        135.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1495.0,
        135.0
      ],
      [
        1680.0,
        1495.0,
        135.0
      ],
      [
        1680.0,
        1554.9998779296875,
        135.0
      ],
      [
        1680.0,
        1555.0,
        140.0
      ],
      [
        1680.0,
        1599.833984375,
        140.0
      ],
      [
        1680.0,
        1599.833984375,
        140.0
      ],
      [
        1680.0,
        1630.0,
        140.0
      ],
      [
        1683.5,
        1410.0,
        140.0
      ],
      [
        1683.5,
        1400.0,
        140.0
      ],
      [
        1683.5,
        1410.0,
        140.0
      ],
      [
        1680.0,
        1554.9998779296875,
        135.0
      ],
      [
        1680.0,
        1554.9998779296875,
        140.0
      ],
      [
        1680.0,
        1400.0,
        135.0
      ],
      [
        1690.0,
        1400.0,
        135.0
      ],
      [
        1685.9998779296875,
        920.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        88.00027465820312
      ],
      [
        1680.0,
        940.0,
        100.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1680.0,
        920.0,
        80.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        960.0,
        98.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        810.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1680.0,
        920.0,
        120.0
      ],
      [
        1680.0,
        875.969970703125,
        105.3599853515625
      ],
      [
        1680.0,
        882.9279174804688,
        105.3599853515625
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1680.0,
        884.030029296875,
        100.0
      ],
      [
        1680.0,
        884.030029296875,
        105.3599853515625
      ],
      [
        1680.0,
        884.030029296875,
        105.3599853515625
      ],
      [
        1655.0,
        810.0,
        190.0
      ],
      [
        1680.0,
        810.0,
        190.0
      ],
      [
        1655.0,
        840.0,
        190.0
      ],
      [
        1680.0,
        840.0,
        190.0
      ],
      [
        1660.0,
        1030.0,
        138.0
      ],
      [
        1660.0,
        1910.0,
        165.0
      ],
      [
        1660.0,
        1820.4000244140625,
        165.0
      ],
      [
        1680.0,
        840.0,
        165.0
      ],
      [
        1660.0,
        840.0,
        190.0
      ],
      [
        1660.0,
        840.0,
        165.0
      ],
      [
        1680.0,
        810.0,
        165.0
      ],
      [
        1660.0,
        810.0,
        190.0
      ],
      [
        1660.0,
        810.0,
        165.0
      ],
      [
        1665.0,
        1917.5001220703125,
        165.0
      ],
      [
        1660.0,
        810.0,
        140.0
      ],
      [
        1660.0,
        840.0,
        140.0
      ],
      [
        1660.0,
        1555.0,
        140.0
      ],
      [
        1660.0,
        1563.966796875,
        140.0
      ],
      [
        1660.0,
        1563.966796875,
        140.0
      ],
      [
        1660.0,
        1630.0,
        140.0
      ],
      [
        1660.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1660.0,
        810.0,
        140.0
      ],
      [
        1667.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        882.5,
        140.0
      ],
      [
        1668.75,
        878.75,
        140.0
      ],
      [
        1668.75,
        881.25,
        140.0
      ],
      [
        1671.25,
        881.25,
        140.0
      ],
      [
        1668.75,
        881.25,
        140.0
      ],
      [
        1660.0,
        1910.0,
        165.0
      ],
      [
        1660.0,
        1910.916015625,
        164.42747497558594
      ],
      [
        1680.0,
        810.0,
        138.0
      ],
      [
        1660.0,
        810.0,
        140.0
      ],
      [
        1660.0,
        810.0,
        138.0
      ],
      [
        1680.0,
        810.0,
        138.0
      ],
      [
        1660.0,
        810.0,
        138.0
      ],
      [
        1680.0,
        1554.9998779296875,
        138.0
      ],
      [
        1660.0,
        1555.0,
        140.0
      ],
      [
        1660.0,
        1555.0,
        138.0
      ],
      [
        1668.0,
        882.0,
        138.0
      ],
      [
        1672.0,
        882.0,
        138.0
      ],
      [
        1668.25,
        878.25,
        138.0
      ],
      [
        1668.25,
        881.75,
        138.0
      ],
      [
        1671.75,
        881.75,
        138.0
      ],
      [
        1668.25,
        881.75,
        138.0
      ],
      [
        1660.0,
        940.0,
        100.0
      ],
      [
        1660.0,
        1120.0,
        100.0
      ],
      [
        1660.0,
        1170.0,
        100.0
      ],
      [
        1660.0,
        920.0,
        100.0
      ],
      [
        1660.0,
        840.0,
        100.0
      ],
      [
        1660.0,
        920.0,
        80.0
      ],
      [
        1660.0,
        920.0,
        100.0
      ],
      [
        1660.0,
        1465.0,
        135.0
      ],
      [
        1660.0,
        1442.5,
        135.0
      ],
      [
        1660.0,
        1465.0,
        135.0
      ],
      [
        1660.0,
        1495.0001220703125,
        135.0
      ],
      [
        1660.0,
        1495.0001220703125,
        135.0
      ],
      [
        1660.0,
        1555.0,
        135.0
      ],
      [
        1680.0,
        810.0,
        135.0
      ],
      [
        1660.0,
        810.0,
        135.0
      ],
      [
        1680.0,
        810.0,
        135.0
      ],
      [
        1660.0,
        810.0,
        135.0
      ],
      [
        1660.0,
        1555.0,
        135.0
      ],
      [
        1667.5,
        877.5,
        135.0
      ],
      [
        1667.5,
        882.5,
        135.0
      ],
      [
        1672.5,
        882.5,
        135.0
      ],
      [
        1667.5,
        882.5,
        135.0
      ],
      [
        1668.125,
        881.875,
        137.5
      ],
      [
        1668.75,
        881.25,
        135.0
      ],
      [
        1671.25,
        881.25,
        135.0
      ],
      [
        1671.875,
        881.875,
        137.5000762939453
      ],
      [
        1668.25,
        882.0,
        138.0
      ],
      [
        1660.0,
        810.0,
        120.0
      ],
      [
        1660.0,
        810.0,
        100.0
      ],
      [
        1660.0,
        940.0,
        120.0
      ],
      [
        1660.0,
        920.0,
        120.0
      ],
      [
        1660.0,
        840.0,
        120.0
      ],
      [
        1660.0,
        810.0,
        120.0
      ],
      [
        1660.0,
        840.0,
        120.0
      ],
      [
        1660.0,
        840.0,
        100.0
      ],
      [
        1671.845458984375,
        863.272705078125,
        110.0
      ],
      [
        1668.254638671875,
        863.272705078125,
        110.0
      ],
      [
        1660.0,
        883.969970703125,
        105.3900146484375
      ],
      [
        1660.0,
        883.969970703125,
        100.0
      ],
      [
        1675.85009765625,
        887.0,
        104.11502838134766
      ],
      [
        1675.85009765625,
        887.0,
        100.0
      ],
      [
        1668.75,
        881.25,
        110.0
      ],
      [
        1671.25,
        881.25,
        110.0
      ],
      [
        1668.75,
        881.25,
        110.0
      ],
      [
        1668.75,
        878.75,
        110.0
      ],
      [
        1675.85009765625,
        887.0,
        104.4749984741211
      ],
      [
        1664.25,
        887.0,
        100.0
      ],
      [
        1664.25,
        887.0,
        104.4749984741211
      ],
      [
        1666.25,
        883.75,
        120.0
      ],
      [
        1673.75,
        883.75,
        120.0
      ],
      [
        1666.25,
        883.75,
        120.0
      ],
      [
        1666.25,
        876.25,
        120.0
      ],
      [
        1668.463134765625,
        862.021484375,
        111.14696502685547
      ],
      [
        1668.7498779296875,
        863.272705078125,
        110.0
      ],
      [
        1660.0,
        940.0,
        118.0
      ],
      [
        1660.0,
        940.0,
        120.0
      ],
      [
        1655.0,
        840.0,
        165.0
      ],
      [
        1660.0,
        840.0,
        165.0
      ],
      [
        1655.0,
        963.0,
        100.0
      ],
      [
        1660.0,
        963.0,
        100.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1660.0,
        1555.0,
        138.0
      ],
      [
        1655.0,
        1555.0,
        138.0
      ],
      [
        1655.5,
        1140.0,
        135.0
      ],
      [
        1655.5,
        1150.0,
        135.0
      ],
      [
        1655.5,
        1555.0,
        135.0
      ],
      [
        1655.0,
        1150.0,
        135.0
      ],
      [
        1655.5,
        1150.0,
        135.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1250.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2010.0,
        490.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1250.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1655.0,
        1500.0,
        490.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        9.39002404720668e-07,
        0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1300.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1655.0,
        1500.0,
        490.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1300.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1630.0006103515625,
        1500.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1300.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        1500.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1300.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1615.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1380.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        940.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        940.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        900.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1600.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -869.9999389648438,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1615.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1615.0,
        870.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        890.0,
        200.0
      ],
      "bbox_max": [
        1615.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1600.0,
        890.0,
        200.0
      ],
      "bbox_max": [
        1615.0,
        900.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1300.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1615.0,
        1500.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1327.071044921875,
        1247.071044921875,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1500.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1347.071044921875,
        1247.071044921875,
        138.0
      ],
      "bbox_max": [
        1615.0,
        1428.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999687075614929,
        -0.007910480722784996,
        0.0
      ],
      "plane_d": -1488.6568603515625,
      "bbox_min": [
        1499.7767333984375,
        1399.7767333984375,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.441412334519555e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0037841796875,
      "bbox_min": [
        1530.0,
        1399.9998779296875,
        138.0
      ],
      "bbox_max": [
        1615.0,
        1400.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1399.9998779296875,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1500.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.441412334519555e-06,
        1.0,
        0.0
      ],
      "plane_d": -1400.0037841796875,
      "bbox_min": [
        1530.0,
        1399.9998779296875,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1400.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1615.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1630.0006103515625,
        1450.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1615.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.00048828125,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1615.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1630.00048828125,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1615.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1630.0006103515625,
        1450.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1615.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1630.0006103515625,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1615.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1630.0006103515625,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1615.0,
        860.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        220.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1615.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1615.0,
        860.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1400.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1615.0,
        860.0,
        215.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -869.9999389648438,
      "bbox_min": [
        1615.0,
        870.0,
        215.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1615.0,
        900.0,
        215.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414002837147564e-06,
        1.0,
        0.0
      ],
      "plane_d": -1399.9959716796875,
      "bbox_min": [
        1615.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1400.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1655.0,
        1450.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1655.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        220.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1630.00048828125,
        960.0,
        98.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1630.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1630.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1630.0006103515625,
        810.0,
        140.0
      ],
      "bbox_max": [
        1650.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1630.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.33334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.33334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1650.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1655.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1650.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1655.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1650.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1650.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1650.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1650.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        1150.0,
        136.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1650.0,
        1150.0,
        131.33334350585938
      ],
      "bbox_max": [
        1655.0,
        1150.0,
        136.6666717529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -5.954652806394733e-07,
        0.0
      ],
      "plane_d": 2025.0010986328125,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2010.0,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.2991988518915605e-07,
        -1.0,
        0.0
      ],
      "plane_d": 1965.00048828125,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        2024.9998779296875,
        2010.0,
        310.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.32583823800086975,
        -0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": 1041.955078125,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866421937942505,
        -0.32583850622177124,
        -0.5244266986846924
      ],
      "plane_d": -726.3786010742188,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2000.48095703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866423726081848,
        -0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": -860.1085815429688,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2000.48095703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.9454345703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320565223693848,
        7.3868721983672e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861572265625,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -0.0,
        0.5546908378601074
      ],
      "plane_d": -1591.306396484375,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826810121536255,
        -0.9238806366920471,
        0.0
      ],
      "plane_d": 1132.740966796875,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        0.0,
        0.5547096133232117
      ],
      "plane_d": 1470.6361083984375,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1990.93505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        -6.367512241922668e-07,
        -0.5547096133232117
      ],
      "plane_d": 1612.0882568359375,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1990.93505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238818287849426,
        -0.38267800211906433,
        0.0
      ],
      "plane_d": -944.1207885742188,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1846.56494140625,
        1990.93505859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1839.0,
        1972.6712646484375,
        123.0
      ],
      "bbox_max": [
        1841.0,
        1977.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        123.0
      ],
      "bbox_max": [
        1841.0,
        1977.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1990.0,
        1965.0001220703125,
        310.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.34324589371681213,
        0.9392455816268921
      ],
      "plane_d": -577.8076171875,
      "bbox_min": [
        1690.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1990.0,
        1965.0001220703125,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1690.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1300.2725830078125,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1690.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1300.2725830078125,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1690.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1690.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1690.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1300.2725830078125,
        165.308837890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1690.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1690.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1690.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1300.2725830078125,
        165.308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1691.018310546875,
        1231.018310546875,
        140.0
      ],
      "bbox_max": [
        1695.0,
        1300.2725830078125,
        165.308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1691.018310546875,
        1231.018310546875,
        160.0
      ],
      "bbox_max": [
        1695.0,
        1245.5452880859375,
        165.308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1875.0,
      "bbox_min": [
        1690.0,
        1180.0,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1965.0001220703125,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071118354797363,
        0.7071017026901245,
        0.0
      ],
      "plane_d": 361.08074951171875,
      "bbox_min": [
        1875.0,
        1364.3779296875,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        188.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1875.0,
        1364.3779296875,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        188.78363037109375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.22360827028751373,
        0.22360506653785706,
        -0.9486833810806274
      ],
      "plane_d": 242.25595092773438,
      "bbox_min": [
        1875.0,
        1364.3779296875,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        188.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750191450119,
        -0.1386750191450119,
        -0.9805806279182434
      ],
      "plane_d": 692.0034790039062,
      "bbox_min": [
        1875.0,
        1780.207275390625,
        139.7664031982422
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        188.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2268.897705078125,
      "bbox_min": [
        1875.0,
        1790.0,
        139.7664031982422
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1810.487060546875,
        139.7664031982422
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1950.0147705078125,
        1789.9998779296875,
        120.0
      ],
      "bbox_max": [
        1990.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1790.1190185546875,
      "bbox_min": [
        1950.0147705078125,
        1789.9998779296875,
        123.0
      ],
      "bbox_max": [
        1952.0146484375,
        1790.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1958.0,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 581.6365966796875,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        135.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036982417106628,
        -0.21534967422485352,
        -0.5547013878822327
      ],
      "plane_d": 1994.7943115234375,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036982417106628,
        -0.21534952521324158,
        0.5547013878822327
      ],
      "plane_d": 1825.610107421875,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984801292419,
        0.21534956991672516,
        0.5547010898590088
      ],
      "plane_d": 1067.5802001953125,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 667.4890747070312,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1814.0325927734375,
        163.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2085.846923828125,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1814.0325927734375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2255.030029296875,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1814.0325927734375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 14.858566284179688,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1730.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.0507580041885376,
        -0.9805808067321777
      ],
      "plane_d": 402.967529296875,
      "bbox_min": [
        1875.0,
        1713.0384521484375,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1806.9615478515625,
        139.82962036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 642.9745483398438,
      "bbox_min": [
        1875.0,
        1713.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1806.9615478515625,
        138.78363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 154.8384246826172,
      "bbox_min": [
        1875.0,
        1713.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1739.792724609375,
        138.7836151123047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1958.0,
        1814.0325927734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1383.288330078125,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1930.0,
        1814.0325927734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 170.1741943359375,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 28.726043701171875,
      "bbox_min": [
        1875.0,
        1705.9674072265625,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984205245972,
        0.21534909307956696,
        -0.5547013282775879
      ],
      "plane_d": 1222.897216796875,
      "bbox_min": [
        1891.9615478515625,
        1727.411865234375,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1891.9615478515625,
        1727.411865234375,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1747.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1895.310791015625,
        1742.5,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1752.4998779296875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2099.71435546875,
      "bbox_min": [
        1875.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1814.0325927734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1891.9615478515625,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1901.8270263671875,
        1792.588134765625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 1980.92431640625,
      "bbox_min": [
        1891.9615478515625,
        1772.5,
        127.5
      ],
      "bbox_max": [
        1901.8270263671875,
        1792.588134765625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 1980.92431640625,
      "bbox_min": [
        1895.3109130859375,
        1767.5,
        127.5
      ],
      "bbox_max": [
        1901.8270263671875,
        1777.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1690.0,
        1230.0,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        230.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1690.0,
        1230.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1690.0,
        1230.0,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1690.0,
        1388.75,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        1770.0,
        1400.0,
        190.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1690.0,
        1388.75,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        1770.0,
        1400.0,
        180.0
      ],
      "bbox_max": [
        1770.0,
        1407.5,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.050758395344018936,
        -0.18943345546722412,
        -0.9805806875228882
      ],
      "plane_d": 432.7808837890625,
      "bbox_min": [
        1807.411865234375,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750191450119,
        -0.1386750191450119,
        -0.9805806279182434
      ],
      "plane_d": 692.0034790039062,
      "bbox_min": [
        1807.411865234375,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534866094589233,
        -0.8036985993385315,
        -0.5547012686729431
      ],
      "plane_d": 1961.5927734375,
      "bbox_min": [
        1807.411865234375,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1169.1121826171875,
      "bbox_min": [
        1807.411865234375,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 1256.763427734375,
      "bbox_min": [
        1810.4530029296875,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2268.897705078125,
      "bbox_min": [
        1870.0,
        1806.9615478515625,
        177.5
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588167190551758,
        -0.9659265279769897,
        -0.0
      ],
      "plane_d": 2209.208984375,
      "bbox_min": [
        1810.4530029296875,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2578.5400390625,
      "bbox_min": [
        1810.4530029296875,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -23.613037109375,
      "bbox_min": [
        1810.4530029296875,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1761.4644775390625,
        165.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1766.2940673828125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1723.75,
        1400.0,
        165.0
      ],
      "bbox_max": [
        1750.0,
        1410.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1727.25,
        1400.0,
        165.0
      ],
      "bbox_max": [
        1750.0,
        1410.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1690.0,
        1231.8634033203125,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1691.25,
        1355.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        165.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1691.25,
        1385.0,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1878.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1695.0,
        1385.0,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1878.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2572184205055237,
        -0.9663532972335815,
        0.0
      ],
      "plane_d": 1341.9161376953125,
      "bbox_min": [
        1810.0,
        1834.461669921875,
        157.0
      ],
      "bbox_max": [
        1847.5001220703125,
        1878.4000244140625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1832.5,
        1834.461669921875,
        160.0
      ],
      "bbox_max": [
        1847.5001220703125,
        1850.400146484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1894332617521286,
        -0.05075898766517639,
        -0.9805806875228882
      ],
      "plane_d": -90.96246337890625,
      "bbox_min": [
        1701.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1849.461669921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        1701.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1849.461669921875,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1830.8980712890625,
        1817.990234375,
        157.5970001220703
      ],
      "bbox_max": [
        1847.5001220703125,
        1849.461669921875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1840.0,
        1820.0,
        160.0
      ],
      "bbox_max": [
        1847.5001220703125,
        1822.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036984801292419,
        -0.2153497189283371,
        -0.5547010898590088
      ],
      "plane_d": -962.815673828125,
      "bbox_min": [
        1774.8236083984375,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1830.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 667.4890747070312,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1830.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1155.244384765625,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1830.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -8.457233889203053e-06,
        -0.5546908378601074
      ],
      "plane_d": -1435.9776611328125,
      "bbox_min": [
        1827.5,
        1817.990234375,
        152.5
      ],
      "bbox_max": [
        1832.4998779296875,
        1830.0001220703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 986.0654296875,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 606.151123046875,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        -0.2588167190551758,
        -0.0
      ],
      "plane_d": 2265.77783203125,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2085.846923828125,
      "bbox_min": [
        1870.0,
        1806.9615478515625,
        145.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2255.030029296875,
      "bbox_min": [
        1870.0,
        1806.9615478515625,
        152.5
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882142782211304,
        0.9659252166748047,
        0.0
      ],
      "plane_d": -1190.8414306640625,
      "bbox_min": [
        1805.8819580078125,
        1703.555419921875,
        140.0
      ],
      "bbox_max": [
        1875.0,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 14.858566284179688,
      "bbox_min": [
        1870.0,
        1703.555419921875,
        145.0
      ],
      "bbox_max": [
        1875.0,
        1713.0384521484375,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252166748047,
        -0.25882142782211304,
        0.0
      ],
      "plane_d": -1288.8211669921875,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": 1354.742919921875,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        0.9659265279769897,
        0.0
      ],
      "plane_d": -2143.2978515625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 1256.763427734375,
      "bbox_min": [
        1805.8819580078125,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588167190551758,
        -0.9659265279769897,
        -0.0
      ],
      "plane_d": 2209.208984375,
      "bbox_min": [
        1805.8819580078125,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": -2199.86669921875,
      "bbox_min": [
        1805.8819580078125,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2578.5400390625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 89.5240478515625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -23.613037109375,
      "bbox_min": [
        1810.4530029296875,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1789.547119140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1840.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1766.2940673828125,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1840.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1766.2940673828125,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        -0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1766.2940673828125,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1761.4644775390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        -0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1759.8297119140625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        -0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1759.8297119140625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1701.0,
        1400.0,
        150.60000610351562
      ],
      "bbox_max": [
        1727.25,
        1410.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1701.0,
        1410.0,
        150.6000213623047
      ],
      "bbox_max": [
        1727.25,
        1410.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1780.0,
      "bbox_min": [
        1710.0,
        1355.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1965.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -96.26071166992188,
      "bbox_min": [
        1780.0,
        1355.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08184313029050827,
        0.30545222759246826,
        -0.9486836194992065
      ],
      "plane_d": -436.4068298339844,
      "bbox_min": [
        1780.0,
        1355.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1425.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08184367418289185,
        0.30545422434806824,
        -0.9486830234527588
      ],
      "plane_d": -135.2258758544922,
      "bbox_min": [
        1780.0,
        1355.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1425.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639495372772217,
        -0.231496661901474,
        -0.44721412658691406
      ],
      "plane_d": 1944.0440673828125,
      "bbox_min": [
        1780.0,
        1364.3779296875,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1425.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324604153633118,
        -0.6324508786201477,
        -0.44721314311027527
      ],
      "plane_d": 2089.463623046875,
      "bbox_min": [
        1801.7926025390625,
        1364.3779296875,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1404.2349853515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22360827028751373,
        0.22360506653785706,
        -0.9486833810806274
      ],
      "plane_d": 242.25595092773438,
      "bbox_min": [
        1867.2354736328125,
        1364.3779296875,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1385.59130859375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277936935425,
        -0.9486833810806274
      ],
      "plane_d": -314.64666748046875,
      "bbox_min": [
        1780.0,
        1404.30224609375,
        136.43409729003906
      ],
      "bbox_max": [
        1785.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1894332617521286,
        -0.05075898766517639,
        -0.9805806875228882
      ],
      "plane_d": -115.47698974609375,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -283.0528564453125,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05075809732079506,
        -0.18943364918231964,
        -0.9805806875228882
      ],
      "plane_d": 383.7527160644531,
      "bbox_min": [
        1780.0,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507580041885376,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 570.5416870117188,
      "bbox_min": [
        1780.0,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18943364918231964,
        0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": -294.1477966308594,
      "bbox_min": [
        1780.0,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": -355.4857177734375,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750191450119,
        -0.1386750191450119,
        -0.9805806875228882
      ],
      "plane_d": 132.65040588378906,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 642.9745483398438,
      "bbox_min": [
        1830.17041015625,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 154.8384246826172,
      "bbox_min": [
        1830.17041015625,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1780.207275390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 581.6365966796875,
      "bbox_min": [
        1830.17041015625,
        1739.792724609375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1780.207275390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.0507580041885376,
        -0.9805808067321777
      ],
      "plane_d": 402.967529296875,
      "bbox_min": [
        1830.17041015625,
        1739.792724609375,
        135.0
      ],
      "bbox_max": [
        1875.0,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        135.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        135.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1766.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1761.4644775390625,
        135.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1766.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1756.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1756.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1831.4644775390625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1751.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1710.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1864.322998046875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.4361193052536692e-06,
        1.0,
        0.0
      ],
      "plane_d": -1554.9974365234375,
      "bbox_min": [
        1710.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1780.0,
        1864.322998046875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        1770.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1780.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1720.0001220703125,
        1656.4769287109375,
        138.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663541316986084,
        0.257215291261673,
        0.0
      ],
      "plane_d": 1209.43017578125,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        138.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1820.39990234375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9654934406280518,
        -0.2604275941848755,
        6.466050399467349e-05
      ],
      "plane_d": 2118.992919921875,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        138.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1722.0,
        1731.0,
        138.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1722.0,
        1731.0,
        138.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        138.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        138.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        138.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.4361193052536692e-06,
        1.0,
        0.0
      ],
      "plane_d": -1554.9974365234375,
      "bbox_min": [
        1711.5,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1864.322998046875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1711.5,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1409.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277936935425,
        -0.9486833810806274
      ],
      "plane_d": -314.64666748046875,
      "bbox_min": [
        1770.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1409.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        1770.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1770.0,
        1409.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105815410614,
        0.7071077823638916,
        0.0
      ],
      "plane_d": -59.6290283203125,
      "bbox_min": [
        1720.0001220703125,
        1656.4769287109375,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1864.322998046875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1720.0001220703125,
        1656.4769287109375,
        135.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663541316986084,
        0.257215291261673,
        0.0
      ],
      "plane_d": 1209.43017578125,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1820.39990234375,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9654934406280518,
        -0.2604275941848755,
        6.466050399467349e-05
      ],
      "plane_d": 2118.992919921875,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1722.0,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1722.0,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        135.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1690.0,
        1245.5452880859375,
        135.0
      ],
      "bbox_max": [
        1713.75,
        1965.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1690.0,
        1245.5452880859375,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1410.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1695.0,
        1385.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1410.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1695.0,
        1410.0,
        146.57142639160156
      ],
      "bbox_max": [
        1702.050048828125,
        1410.0,
        151.99998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1690.0,
        1400.0,
        143.7142791748047
      ],
      "bbox_max": [
        1695.0,
        1410.0,
        148.5714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1690.0,
        1410.0,
        143.71429443359375
      ],
      "bbox_max": [
        1695.0,
        1410.0,
        148.5714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1690.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1713.75,
        1554.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.4361193052536692e-06,
        1.0,
        0.0
      ],
      "plane_d": -1554.9974365234375,
      "bbox_min": [
        1690.0,
        1505.0,
        135.0
      ],
      "bbox_max": [
        1713.75,
        1554.9998779296875,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071053981781006,
        0.0,
        -0.7071082592010498
      ],
      "plane_d": -1107.521484375,
      "bbox_min": [
        1697.4998779296875,
        1505.0,
        135.0
      ],
      "bbox_max": [
        1701.2811279296875,
        1540.0001220703125,
        135.0057373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -3.2285144698107615e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1535.0548095703125,
      "bbox_min": [
        1697.5,
        1525.0,
        135.0
      ],
      "bbox_max": [
        1701.2811279296875,
        1540.0001220703125,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.2285144698107615e-05,
        1.0,
        0.0
      ],
      "plane_d": -1540.054931640625,
      "bbox_min": [
        1697.5001220703125,
        1540.0,
        135.0
      ],
      "bbox_max": [
        1701.2811279296875,
        1540.0001220703125,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.228410423616879e-05,
        1.0,
        0.0
      ],
      "plane_d": -1509.9451904296875,
      "bbox_min": [
        1697.5,
        1510.0,
        135.0
      ],
      "bbox_max": [
        1701.2811279296875,
        1510.0001220703125,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1847.499755859375,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        135.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -895.1546020507812,
      "bbox_min": [
        1847.499755859375,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534909307956696,
        -0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": 1933.8580322265625,
      "bbox_min": [
        1847.499755859375,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1036.60595703125,
      "bbox_min": [
        1847.499755859375,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659233689308167,
        -0.2588285207748413,
        0.0
      ],
      "plane_d": -1344.7164306640625,
      "bbox_min": [
        1853.4998779296875,
        1704.4520263671875,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1815.5478515625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5795527100563049,
        -0.15529675781726837,
        0.8000009655952454
      ],
      "plane_d": -905.228271484375,
      "bbox_min": [
        1853.4998779296875,
        1743.03564453125,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1815.5478515625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2099.71435546875,
      "bbox_min": [
        1853.4998779296875,
        1743.03564453125,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1815.5478515625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1853.4998779296875,
        1743.03564453125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1750.1878662109375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.524169921875,
      "bbox_min": [
        1855.499755859375,
        1743.03564453125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1748.1173095703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2099.71435546875,
      "bbox_min": [
        1873.9937744140625,
        1811.5517578125,
        124.86862182617188
      ],
      "bbox_max": [
        1875.0,
        1813.6246337890625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2241.16259765625,
      "bbox_min": [
        1847.499755859375,
        1703.555419921875,
        126.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1847.499755859375,
        1703.555419921875,
        126.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1847.499755859375,
        1751.18701171875,
        131.50523376464844
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1847.4998779296875,
        1751.18701171875,
        133.44656372070312
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2099.71435546875,
      "bbox_min": [
        1872.070556640625,
        1812.618408203125,
        126.0
      ],
      "bbox_max": [
        1875.0,
        1816.4444580078125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1847.5,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1857.5001220703125,
        1821.8270263671875,
        127.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1847.5,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1857.499755859375,
        1821.8270263671875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1036.60595703125,
      "bbox_min": [
        1847.5,
        1698.940185546875,
        120.0
      ],
      "bbox_max": [
        1857.499755859375,
        1821.0596923828125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1847.5,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1855.499755859375,
        1746.692626953125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1847.5,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1851.8828125,
        1741.51806640625,
        124.75614166259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1849.5,
        1738.7801513671875,
        123.0
      ],
      "bbox_max": [
        1851.8828125,
        1741.51806640625,
        124.75614166259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1036.60595703125,
      "bbox_min": [
        1851.4998779296875,
        1698.1728515625,
        126.0
      ],
      "bbox_max": [
        1853.4998779296875,
        1821.8270263671875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1792.4072265625,
      "bbox_min": [
        1851.5,
        1820.5238037109375,
        126.0
      ],
      "bbox_max": [
        1853.4998779296875,
        1821.8270263671875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1690.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1965.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1780.0,
      "bbox_min": [
        1690.0,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1965.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": -1185.6717529296875,
      "bbox_min": [
        1780.0,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639494180679321,
        -0.23149722814559937,
        0.4472140371799469
      ],
      "plane_d": 1827.7689208984375,
      "bbox_min": [
        1795.8818359375,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1820.529052734375,
        1425.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324584484100342,
        -0.6324530243873596,
        0.4472128450870514
      ],
      "plane_d": 1973.187744140625,
      "bbox_min": [
        1801.7926025390625,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1820.529052734375,
        1405.529052734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324604153633118,
        -0.6324508786201477,
        -0.44721314311027527
      ],
      "plane_d": 2089.463623046875,
      "bbox_min": [
        1806.2755126953125,
        1389.033935546875,
        130.0
      ],
      "bbox_max": [
        1820.529052734375,
        1405.529052734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639495372772217,
        -0.231496661901474,
        -0.44721412658691406
      ],
      "plane_d": 1944.0440673828125,
      "bbox_min": [
        1798.469970703125,
        1397.1636962890625,
        130.0
      ],
      "bbox_max": [
        1811.105224609375,
        1425.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324604153633118,
        -0.6324508786201477,
        -0.44721314311027527
      ],
      "plane_d": 2089.463623046875,
      "bbox_min": [
        1804.0340576171875,
        1397.1636962890625,
        130.0
      ],
      "bbox_max": [
        1811.105224609375,
        1405.529052734375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2696060593953007e-06,
        0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": -1327.1180419921875,
      "bbox_min": [
        1780.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2696024214164936e-06,
        -0.8320440649986267,
        0.5547096133232117
      ],
      "plane_d": 1206.4644775390625,
      "bbox_min": [
        1780.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1994.949951171875,
      "bbox_min": [
        1780.0,
        1529.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3258281946182251,
        -0.786641001701355,
        0.5244348049163818
      ],
      "plane_d": 547.6212158203125,
      "bbox_min": [
        1819.9998779296875,
        1529.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1542.5001220703125,
        129.4302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866417765617371,
        -0.325839102268219,
        0.5244268774986267
      ],
      "plane_d": -1001.8455200195312,
      "bbox_min": [
        1825.3033447265625,
        1533.6611328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1542.5001220703125,
        128.7172393798828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866443395614624,
        -0.3258346617221832,
        -0.5244259238243103
      ],
      "plane_d": -868.1282348632812,
      "bbox_min": [
        1825.3033447265625,
        1537.1966552734375,
        127.5
      ],
      "bbox_max": [
        1827.5001220703125,
        1542.5001220703125,
        128.7172393798828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583844661712646,
        -0.7866380214691162,
        -0.5244329571723938
      ],
      "plane_d": 681.32861328125,
      "bbox_min": [
        1820.0,
        1535.0,
        127.5
      ],
      "bbox_max": [
        1826.6885986328125,
        1538.58203125,
        129.4302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866443395614624,
        -0.3258346617221832,
        -0.5244259238243103
      ],
      "plane_d": -868.1282348632812,
      "bbox_min": [
        1825.3033447265625,
        1536.2867431640625,
        127.5
      ],
      "bbox_max": [
        1826.6885986328125,
        1538.58203125,
        129.4302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883490443229675,
        -0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 76.0384521484375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -65.40982055664062,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2136.398193359375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1829.1114501953125,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 999.9329833984375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036968111991882,
        0.21535371243953705,
        0.5547019839286804
      ],
      "plane_d": -1876.1668701171875,
      "bbox_min": [
        1780.0,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1792.0704345703125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1780.0,
        1749.8809814453125,
        120.0
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        123.92837524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1780.0,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1792.0704345703125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1780.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.118896484375,
        123.9283676147461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2522.62890625,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659239649772644,
        0.25882601737976074,
        0.0
      ],
      "plane_d": 1298.810791015625,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659250974655151,
        -0.2588217258453369,
        0.0
      ],
      "plane_d": 2209.872802734375,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 33.613037109375,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5795534253120422,
        0.15529534220695496,
        0.800000786781311
      ],
      "plane_d": 680.8850708007812,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5795546174049377,
        -0.15529291331768036,
        0.8000003695487976
      ],
      "plane_d": 1227.5225830078125,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242696166038513,
        -0.4242696166038513,
        0.7999941110610962
      ],
      "plane_d": 1415.1978759765625,
      "bbox_min": [
        1819.4185791015625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1819.418701171875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1828.1173095703125,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1828.1173095703125,
        1738.7801513671875,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529368817806244,
        -0.5795575380325317,
        0.7999982237815857
      ],
      "plane_d": 1193.5885009765625,
      "bbox_min": [
        1828.1173095703125,
        1738.7801513671875,
        123.0
      ],
      "bbox_max": [
        1830.4998779296875,
        1781.2197265625,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.1173095703125,
        1778.4822998046875,
        123.0
      ],
      "bbox_max": [
        1830.499755859375,
        1781.2197265625,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036941885948181,
        -0.21534796059131622,
        -0.5547080636024475
      ],
      "plane_d": -976.6776123046875,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1780.0,
        1767.5,
        131.07164001464844
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.118896484375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1780.0,
        1775.4552001953125,
        126.0
      ],
      "bbox_max": [
        1784.4520263671875,
        1792.5880126953125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320440649986267,
        -0.5547096133232117
      ],
      "plane_d": 1347.9130859375,
      "bbox_min": [
        1780.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1536.2867431640625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583844661712646,
        -0.7866380214691162,
        -0.5244329571723938
      ],
      "plane_d": 681.32861328125,
      "bbox_min": [
        1819.9998779296875,
        1529.9998779296875,
        127.5
      ],
      "bbox_max": [
        1826.2132568359375,
        1536.2867431640625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1521.5,
      "bbox_min": [
        1780.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1528.6776123046875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1780.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1528.6776123046875,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.7438646864320617e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1523.5030517578125,
      "bbox_min": [
        1780.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1528.6776123046875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833963394165,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": 709.1990356445312,
      "bbox_min": [
        1820.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1824.828125,
        1523.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826851546764374,
        0.9238787889480591,
        0.0
      ],
      "plane_d": -711.042236328125,
      "bbox_min": [
        1819.9998779296875,
        1523.4998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1528.6776123046875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833963394165,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": 709.1990356445312,
      "bbox_min": [
        1824.828125,
        1523.4998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1526.6776123046875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1820.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1520.1776123046875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583823800086975,
        0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": -527.9386596679688,
      "bbox_min": [
        1820.0,
        1510.0,
        127.5
      ],
      "bbox_max": [
        1827.5,
        1516.0355224609375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.4361193052536692e-06,
        1.0,
        0.0
      ],
      "plane_d": -1554.9974365234375,
      "bbox_min": [
        1690.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1864.322998046875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1690.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.0345094071672065e-06,
        0.0
      ],
      "plane_d": 1695.0030517578125,
      "bbox_min": [
        1694.9998779296875,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1697.5,
      "bbox_min": [
        1695.0,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6246950626373291,
        0.7808688282966614
      ],
      "plane_d": -1050.2685546875,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6246764659881592,
        0.7808837294578552
      ],
      "plane_d": -1037.74853515625,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1520.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0500294087687507e-05,
        0.6246764659881592,
        -0.7808837294578552
      ],
      "plane_d": -840.1331787109375,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1520.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0503017114824615e-05,
        -0.624732255935669,
        0.7808391451835632
      ],
      "plane_d": 851.936279296875,
      "bbox_min": [
        1695.0,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1520.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0507484552799724e-05,
        -0.624732255935669,
        -0.7808390855789185
      ],
      "plane_d": 1049.592041015625,
      "bbox_min": [
        1695.0,
        1505.0,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1520.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1505.0,
      "bbox_min": [
        1695.0,
        1505.0,
        125.0
      ],
      "bbox_max": [
        1697.5,
        1520.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.883289511781186e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1520.082763671875,
      "bbox_min": [
        1695.0001220703125,
        1519.9998779296875,
        125.0
      ],
      "bbox_max": [
        1697.4998779296875,
        1520.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0500294087687507e-05,
        -0.6246764659881592,
        -0.7808837294578552
      ],
      "plane_d": 1061.9031982421875,
      "bbox_min": [
        1695.0,
        1525.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246764659881592,
        0.7808837294578552
      ],
      "plane_d": 864.391357421875,
      "bbox_min": [
        1695.0,
        1525.0,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6246950626373291,
        -0.7808688282966614
      ],
      "plane_d": -852.708740234375,
      "bbox_min": [
        1695.0,
        1525.0,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.8825746489455923e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1539.917236328125,
      "bbox_min": [
        1695.0,
        1525.0,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1695.0,
        1525.0,
        125.0
      ],
      "bbox_max": [
        1697.5,
        1525.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": -1424.4149169921875,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": 482.29412841796875,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": -682.9775390625,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238899350166321,
        0.3826584219932556
      ],
      "plane_d": 1388.81640625,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": -1185.6717529296875,
      "bbox_min": [
        1697.4998779296875,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1554.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -8.138086741382722e-06,
        2.170156585634686e-05
      ],
      "plane_d": 1740.0093994140625,
      "bbox_min": [
        1697.5,
        1490.0,
        120.0
      ],
      "bbox_max": [
        1740.0,
        1515.0,
        135.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 732.4815673828125,
      "bbox_min": [
        1710.0001220703125,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1508.3333740234375,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        1710.0001220703125,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1508.3333740234375,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547095537185669,
        1.3543043678510003e-05,
        0.8320440053939819
      ],
      "plane_d": -1062.00927734375,
      "bbox_min": [
        1710.0001220703125,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1508.3333740234375,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -1.3542485248763114e-05,
        0.8320503234863281
      ],
      "plane_d": 846.215576171875,
      "bbox_min": [
        1710.0001220703125,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1508.3333740234375,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": 1710.036865234375,
      "bbox_min": [
        1710.0001220703125,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1507.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.228410423616879e-05,
        1.0,
        0.0
      ],
      "plane_d": -1509.9451904296875,
      "bbox_min": [
        1697.5,
        1505.0,
        131.22462463378906
      ],
      "bbox_max": [
        1701.275390625,
        1510.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103143095970154e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1509.8951416015625,
      "bbox_min": [
        1719.0,
        1510.0,
        127.49990844726562
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1719.0,
      "bbox_min": [
        1719.0,
        1510.0,
        127.49990844726562
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00024420025874860585,
        -0.0
      ],
      "plane_d": -1721.368896484375,
      "bbox_min": [
        1719.0,
        1510.0,
        127.50012969970703
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.459083695313893e-05,
        -0.8944708704948425,
        0.44712623953819275
      ],
      "plane_d": 1291.983642578125,
      "bbox_min": [
        1719.0,
        1510.0,
        131.0
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1719.9923095703125,
      "bbox_min": [
        1719.9998779296875,
        1510.4998779296875,
        128.2496795654297
      ],
      "bbox_max": [
        1719.9998779296875,
        1513.0001220703125,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.2696060593953007e-06,
        0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": -1327.1180419921875,
      "bbox_min": [
        1697.4998779296875,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1554.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -1.627604251552839e-05
      ],
      "plane_d": 1740.001953125,
      "bbox_min": [
        1710.0,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1740.0,
        1515.0,
        127.50012969970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1710.0,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1514.9998779296875,
        127.50012969970703
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1710.0,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1514.9998779296875,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": 1710.036865234375,
      "bbox_min": [
        1710.0,
        1505.0,
        120.0
      ],
      "bbox_max": [
        1730.0,
        1510.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -1.3542485248763114e-05,
        0.8320503234863281
      ],
      "plane_d": 846.215576171875,
      "bbox_min": [
        1710.0,
        1507.0001220703125,
        123.0
      ],
      "bbox_max": [
        1713.0,
        1510.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1715.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1725.0,
        1514.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.88278874399839e-06,
        0.0
      ],
      "plane_d": -1724.99267578125,
      "bbox_min": [
        1715.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1725.0,
        1514.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -2.708510464799474e-06,
        0.8320503234863281
      ],
      "plane_d": 848.9727783203125,
      "bbox_min": [
        1715.0,
        1510.0,
        123.0
      ],
      "bbox_max": [
        1725.0,
        1512.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -2.708483862079447e-06,
        0.8320503234863281
      ],
      "plane_d": -1059.1959228515625,
      "bbox_min": [
        1722.0,
        1510.0,
        123.0
      ],
      "bbox_max": [
        1725.0,
        1512.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103143095970154e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1509.8951416015625,
      "bbox_min": [
        1719.0,
        1510.0,
        125.0
      ],
      "bbox_max": [
        1721.0001220703125,
        1511.6666259765625,
        127.50012969970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.5,
      "bbox_min": [
        1719.0,
        1510.0,
        125.0
      ],
      "bbox_max": [
        1721.0001220703125,
        1511.6666259765625,
        127.50012969970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00024420025874860585,
        -0.0
      ],
      "plane_d": -1721.368896484375,
      "bbox_min": [
        1719.0,
        1510.0,
        125.0
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        127.50012969970703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1719.0,
      "bbox_min": [
        1719.0,
        1510.0,
        125.0
      ],
      "bbox_max": [
        1719.0,
        1510.5,
        127.49990844726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1719.9923095703125,
      "bbox_min": [
        1719.9998779296875,
        1510.4998779296875,
        125.0
      ],
      "bbox_max": [
        1719.9998779296875,
        1511.6666259765625,
        126.75016784667969
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320440649986267,
        -0.5547096133232117
      ],
      "plane_d": 1347.9130859375,
      "bbox_min": [
        1697.4998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1554.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -6.10351571594947e-06,
        -0.0
      ],
      "plane_d": 1740.009521484375,
      "bbox_min": [
        1697.5,
        1530.0,
        120.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1554.9998779296875,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -956.5804443359375,
      "bbox_min": [
        1709.9998779296875,
        1536.66650390625,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        1709.9998779296875,
        1536.66650390625,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -1.3542485248763114e-05,
        0.8320503234863281
      ],
      "plane_d": -1061.9527587890625,
      "bbox_min": [
        1709.9998779296875,
        1536.66650390625,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547095537185669,
        -1.3543043678510003e-05,
        0.8320440053939819
      ],
      "plane_d": 846.2327270507812,
      "bbox_min": [
        1709.9998779296875,
        1536.66650390625,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": -1729.9625244140625,
      "bbox_min": [
        1709.9998779296875,
        1538.0,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.2285144698107615e-05,
        1.0,
        0.0
      ],
      "plane_d": -1540.054931640625,
      "bbox_min": [
        1697.5,
        1534.9998779296875,
        131.22462463378906
      ],
      "bbox_max": [
        1701.275390625,
        1540.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103888154029846e-05,
        1.0,
        0.0
      ],
      "plane_d": -1535.60498046875,
      "bbox_min": [
        1719.0,
        1535.0,
        126.74993896484375
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1719.0,
      "bbox_min": [
        1719.0,
        1535.0,
        126.74993896484375
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002442002296447754,
        0.0
      ],
      "plane_d": -1721.3748779296875,
      "bbox_min": [
        1719.0,
        1535.0,
        126.75015258789062
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -1431.9781494140625,
      "bbox_min": [
        1719.0,
        1535.0,
        131.0
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1719.9923095703125,
      "bbox_min": [
        1720.0,
        1531.9998779296875,
        127.49992370605469
      ],
      "bbox_max": [
        1720.0,
        1535.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.2696024214164936e-06,
        -0.8320440649986267,
        0.5547096133232117
      ],
      "plane_d": 1206.4644775390625,
      "bbox_min": [
        1697.4998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1540.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1709.9998779296875,
        1530.0,
        120.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1540.0,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1709.9998779296875,
        1530.0,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        127.49992370605469
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -2.4414661311311647e-05,
        -1.0,
        3.6621993785956874e-05
      ],
      "plane_d": 1535.0372314453125,
      "bbox_min": [
        1709.9998779296875,
        1530.0,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": -1729.9625244140625,
      "bbox_min": [
        1709.9998779296875,
        1535.0,
        120.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1540.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -1.3542485248763114e-05,
        0.8320503234863281
      ],
      "plane_d": -1061.9527587890625,
      "bbox_min": [
        1727.0,
        1535.0,
        123.0
      ],
      "bbox_max": [
        1730.0001220703125,
        1538.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.88278874399839e-06,
        0.0
      ],
      "plane_d": -1724.99267578125,
      "bbox_min": [
        1714.9998779296875,
        1530.0,
        120.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1535.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1714.9998779296875,
        1530.0001220703125,
        120.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1535.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -2.708483862079447e-06,
        0.8320503234863281
      ],
      "plane_d": -1059.1959228515625,
      "bbox_min": [
        1714.9998779296875,
        1532.0,
        123.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1535.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -2.708510464799474e-06,
        0.8320503234863281
      ],
      "plane_d": 848.9727783203125,
      "bbox_min": [
        1714.9998779296875,
        1532.0001220703125,
        123.0
      ],
      "bbox_max": [
        1717.9998779296875,
        1534.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1719.0,
        1533.33349609375,
        125.0
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        127.49992370605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103888154029846e-05,
        1.0,
        0.0
      ],
      "plane_d": -1535.60498046875,
      "bbox_min": [
        1719.0,
        1535.0,
        125.0
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        127.49992370605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002442002296447754,
        0.0
      ],
      "plane_d": -1721.3748779296875,
      "bbox_min": [
        1719.0,
        1535.0,
        125.0
      ],
      "bbox_max": [
        1721.0,
        1535.5,
        127.49992370605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1719.0,
      "bbox_min": [
        1719.0,
        1535.0,
        125.0
      ],
      "bbox_max": [
        1719.0,
        1535.5,
        127.49992370605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1719.9923095703125,
      "bbox_min": [
        1720.0,
        1533.33349609375,
        125.0
      ],
      "bbox_max": [
        1720.0,
        1535.0,
        127.49992370605469
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1697.4998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1535.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1521.5,
      "bbox_min": [
        1714.9998779296875,
        1512.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1532.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.7438646864320617e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1523.5030517578125,
      "bbox_min": [
        1714.9998779296875,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1532.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.88278874399839e-06,
        0.0
      ],
      "plane_d": -1724.99267578125,
      "bbox_min": [
        1715.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1523.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1715.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1715.0,
        1523.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1523.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1714.9998779296875,
        1523.5,
        120.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1532.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.88278874399839e-06,
        0.0
      ],
      "plane_d": -1724.99267578125,
      "bbox_min": [
        1725.0,
        1523.5,
        120.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1532.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1715.0,
        1512.9998779296875,
        120.0
      ],
      "bbox_max": [
        1725.0,
        1521.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.88278874399839e-06,
        0.0
      ],
      "plane_d": -1724.99267578125,
      "bbox_min": [
        1725.0,
        1512.9998779296875,
        120.0
      ],
      "bbox_max": [
        1725.0,
        1521.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1697.4998779296875,
        1510.0,
        123.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1535.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -2.708510464799474e-06,
        0.8320503234863281
      ],
      "plane_d": 848.9727783203125,
      "bbox_min": [
        1714.9998779296875,
        1511.6666259765625,
        123.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1533.33349609375,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -2.708483862079447e-06,
        0.8320503234863281
      ],
      "plane_d": -1059.1959228515625,
      "bbox_min": [
        1722.0,
        1511.6666259765625,
        123.0
      ],
      "bbox_max": [
        1725.0001220703125,
        1533.33349609375,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.98243707625079e-06,
        0.0
      ],
      "plane_d": -1719.9923095703125,
      "bbox_min": [
        1697.4998779296875,
        1510.0,
        125.0
      ],
      "bbox_max": [
        1721.0001220703125,
        1535.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.5,
      "bbox_min": [
        1719.9998779296875,
        1510.0001220703125,
        126.74993896484375
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        128.24989318847656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00024420025874860585,
        -0.0
      ],
      "plane_d": -1721.368896484375,
      "bbox_min": [
        1721.0,
        1510.0001220703125,
        126.74993896484375
      ],
      "bbox_max": [
        1721.0001220703125,
        1510.5,
        128.24989318847656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663533568382263,
        0.2572184205055237,
        6.749428575858474e-05
      ],
      "plane_d": 1209.4151611328125,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9654912948608398,
        -0.26043570041656494,
        0.0
      ],
      "plane_d": 2119.011962890625,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1720.0001220703125,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1722.0,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1722.0,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        -0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1722.0,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1760.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1720.0001220703125,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1720.0001220703125,
        1756.268310546875,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 1661.777099609375,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1730.78369140625,
        1793.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1760.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486775994300842,
        0.3162451684474945
      ],
      "plane_d": -1678.529296875,
      "bbox_min": [
        1729.822509765625,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1731.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -664.078369140625,
      "bbox_min": [
        1729.8226318359375,
        1728.0,
        123.0
      ],
      "bbox_max": [
        1730.6318359375,
        1731.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.9852294921875,
        1767.5,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8036941885948181,
        -0.21534796059131622,
        -0.5547080636024475
      ],
      "plane_d": -976.6776123046875,
      "bbox_min": [
        1778.1728515625,
        1770.118896484375,
        125.39698791503906
      ],
      "bbox_max": [
        1780.0,
        1779.3189697265625,
        131.07164001464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1778.1728515625,
        1772.4998779296875,
        125.39698791503906
      ],
      "bbox_max": [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1793.0,
        124.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1778.1728515625,
        1770.118896484375,
        123.9283676147461
      ],
      "bbox_max": [
        1780.0,
        1773.90185546875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.67765664527542e-06,
        0.0
      ],
      "plane_d": 1749.9901123046875,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1778.1729736328125,
        1740.681396484375,
        125.39702606201172
      ],
      "bbox_max": [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036968111991882,
        0.21535371243953705,
        0.5547019839286804
      ],
      "plane_d": -1876.1668701171875,
      "bbox_min": [
        1778.1729736328125,
        1740.681396484375,
        125.39702606201172
      ],
      "bbox_max": [
        1780.0,
        1747.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -664.078369140625,
      "bbox_min": [
        1729.8226318359375,
        1728.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        124.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        5.6776571000227705e-06,
        -1.2490845620050095e-05
      ],
      "plane_d": 1749.9915771484375,
      "bbox_min": [
        1750.0,
        1744.5001220703125,
        123.0
      ],
      "bbox_max": [
        1780.0,
        1750.5001220703125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036968111991882,
        0.21535371243953705,
        0.5547019839286804
      ],
      "plane_d": -1876.1668701171875,
      "bbox_min": [
        1778.1729736328125,
        1746.09814453125,
        123.92837524414062
      ],
      "bbox_max": [
        1780.0,
        1749.8809814453125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.367607738866354e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861328125,
      "bbox_min": [
        1822.499755859375,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1964.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.32583823800086975,
        0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": -527.9386596679688,
      "bbox_min": [
        1822.499755859375,
        1513.1065673828125,
        127.5
      ],
      "bbox_max": [
        1832.5001220703125,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534909307956696,
        0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": -1687.64501953125,
      "bbox_min": [
        1822.499755859375,
        1531.0355224609375,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866443395614624,
        -0.3258346617221832,
        -0.5244259238243103
      ],
      "plane_d": -868.1282348632812,
      "bbox_min": [
        1822.5001220703125,
        1531.0355224609375,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1542.5001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583844661712646,
        -0.7866380214691162,
        -0.5244329571723938
      ],
      "plane_d": 681.32861328125,
      "bbox_min": [
        1822.5001220703125,
        1531.0355224609375,
        129.4302978515625
      ],
      "bbox_max": [
        1828.8388671875,
        1536.2867431640625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1141.376708984375,
      "bbox_min": [
        1822.499755859375,
        1751.18701171875,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        133.44696044921875
      ],
      "bbox_max": [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        131.50572204589844
      ],
      "bbox_max": [
        1832.4998779296875,
        1758.62353515625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1831.4644775390625,
        1751.18701171875,
        133.44677734375
      ],
      "bbox_max": [
        1832.4998779296875,
        1751.4644775390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1827.5,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1964.9998779296875,
        135.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1964.9998779296875,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1841.0,
      "bbox_min": [
        1830.499755859375,
        1517.3492431640625,
        120.0
      ],
      "bbox_max": [
        1849.5,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1839.0,
      "bbox_min": [
        1830.499755859375,
        1517.3492431640625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833963394165,
        0.0
      ],
      "plane_d": -1110.5732421875,
      "bbox_min": [
        1839.0,
        1520.8701171875,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1839.0,
        1680.0,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1736.5025634765625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1840.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1736.5025634765625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1839.0,
        1520.8701171875,
        120.0
      ],
      "bbox_max": [
        1840.859619140625,
        1523.0545654296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833963394165,
        0.0
      ],
      "plane_d": -1110.5732421875,
      "bbox_min": [
        1832.4349365234375,
        1526.650634765625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1537.671630859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833963394165,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": 709.1990356445312,
      "bbox_min": [
        1832.4349365234375,
        1526.650634765625,
        120.0
      ],
      "bbox_max": [
        1834.8492431640625,
        1527.6507568359375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1830.499755859375,
        1525.8492431640625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1830.499755859375,
        1781.2197265625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826851546764374,
        0.9238787889480591,
        0.0
      ],
      "plane_d": -711.042236328125,
      "bbox_min": [
        1830.5,
        1525.8492431640625,
        120.0
      ],
      "bbox_max": [
        1833.43505859375,
        1529.06494140625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833963394165,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": 709.1990356445312,
      "bbox_min": [
        1830.5,
        1525.8492431640625,
        120.09761047363281
      ],
      "bbox_max": [
        1832.43505859375,
        1526.6507568359375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1849.5,
        1738.7801513671875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        123.0
      ],
      "bbox_max": [
        1852.5,
        1783.765380859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866423726081848,
        0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": 887.7854614257812,
      "bbox_min": [
        1828.4998779296875,
        1514.520751953125,
        123.0
      ],
      "bbox_max": [
        1851.5,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1828.4998779296875,
        1514.520751953125,
        123.0
      ],
      "bbox_max": [
        1851.5,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.4998779296875,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.5,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1828.4998779296875,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.5,
        1778.482421875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529368817806244,
        -0.5795575380325317,
        0.7999982237815857
      ],
      "plane_d": 1193.5885009765625,
      "bbox_min": [
        1828.4998779296875,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.5,
        1778.482421875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1828.4998779296875,
        1741.517578125,
        124.7558822631836
      ],
      "bbox_max": [
        1851.5,
        1778.482421875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242696166038513,
        -0.4242696166038513,
        0.7999941110610962
      ],
      "plane_d": 1415.1978759765625,
      "bbox_min": [
        1828.4998779296875,
        1741.517578125,
        124.7558822631836
      ],
      "bbox_max": [
        1851.5,
        1744.69287109375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1849.812255859375,
        1741.51806640625,
        124.75614166259766
      ],
      "bbox_max": [
        1851.5,
        1744.6927490234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866414189338684,
        0.32583993673324585,
        -0.5244269967079163
      ],
      "plane_d": 1021.5097045898438,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        126.0
      ],
      "bbox_max": [
        1852.5,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866423726081848,
        0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": 887.7854614257812,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        126.0
      ],
      "bbox_max": [
        1852.5,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583823800086975,
        0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": -527.9386596679688,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1827.5,
        1513.1065673828125,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1222.016357421875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1848.5355224609375,
        1751.4644775390625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        133.44656372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        126.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        126.0
      ],
      "bbox_max": [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1766.2940673828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1766.2940673828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1846.2940673828125,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        126.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        126.0
      ],
      "bbox_max": [
        1831.4644775390625,
        1756.2940673828125,
        133.44677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1965.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1655.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1965.0,
        169.13043212890625
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1965.0,
        165.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1682.391357421875,
        1060.4761962890625,
        90.47618865966797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1965.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1680.0,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1965.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        164.34780883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1755.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1855.0,
      "bbox_min": [
        1680.0,
        1765.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0,
        1865.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1680.0,
        1865.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1680.0,
        1765.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703143189894e-05,
        1.0,
        0.0
      ],
      "plane_d": -1815.0205078125,
      "bbox_min": [
        1680.0,
        1814.9998779296875,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1680.0,
        1765.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1665.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        0.0
      ],
      "plane_d": -1715.0205078125,
      "bbox_min": [
        1680.0,
        1714.9998779296875,
        120.0
      ],
      "bbox_max": [
        1689.9998779296875,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1680.0,
        1665.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        139.13043212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1610.0,
        138.26087951660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        1400.0,
        119.99995422363281
      ],
      "bbox_max": [
        1680.0001220703125,
        1965.0,
        165.0381622314453
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        1630.0,
        119.99995422363281
      ],
      "bbox_max": [
        1680.0001220703125,
        1965.0,
        165.0381622314453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        8.137954864650965e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1949.986328125,
      "bbox_min": [
        1664.9998779296875,
        1949.9998779296875,
        140.0
      ],
      "bbox_max": [
        1680.0,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1655.0,
        1910.0,
        140.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1918.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1135.2578125,
      "bbox_min": [
        1655.0,
        1910.0,
        140.0
      ],
      "bbox_max": [
        1665.0,
        1918.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.818099190131761e-05,
        2.4206688976846635e-05
      ],
      "plane_d": -1665.0382080078125,
      "bbox_min": [
        1665.0,
        1910.0,
        140.0
      ],
      "bbox_max": [
        1665.0,
        1918.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1135.2578125,
      "bbox_min": [
        1655.0,
        1910.0,
        119.99995422363281
      ],
      "bbox_max": [
        1665.0,
        1950.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.818099190131761e-05,
        2.4206688976846635e-05
      ],
      "plane_d": -1665.0382080078125,
      "bbox_min": [
        1664.9998779296875,
        1910.0,
        119.99995422363281
      ],
      "bbox_max": [
        1665.0,
        1949.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1965.0,
        240.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1680.0,
        810.0,
        166.66665649414062
      ],
      "bbox_max": [
        1690.0,
        1965.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        190.0
      ],
      "bbox_max": [
        1690.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        840.0,
        190.0
      ],
      "bbox_max": [
        1690.0,
        840.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        810.0,
        166.66665649414062
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        166.66665649414062
      ],
      "bbox_max": [
        1690.0,
        810.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0,
        1390.0,
        166.6666717529297
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1680.0,
        1390.0,
        166.6666717529297
      ],
      "bbox_max": [
        1690.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1917.5001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1917.5001220703125,
        179.9998016357422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        170.0
      ],
      "bbox_max": [
        1687.5,
        1910.0,
        179.9998016357422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1680.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1680.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1680.0,
        1410.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        164.34780883789062
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0517671802954283e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1555.0050048828125,
      "bbox_min": [
        1680.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1680.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1410.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1680.0,
        1410.0,
        138.0
      ],
      "bbox_max": [
        1683.5,
        1410.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        138.2608642578125
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1620.0,
        139.13043212890625
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1685.9998779296875,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        920.0,
        88.00027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1680.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1680.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1680.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1680.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1680.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1680.0,
        875.969970703125,
        100.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16547328233718872,
        0.986214280128479,
        -0.0
      ],
      "plane_d": -1148.751220703125,
      "bbox_min": [
        1680.0,
        875.969970703125,
        100.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6781800389289856,
        0.0,
        0.7348957657814026
      ],
      "plane_d": 1063.0810546875,
      "bbox_min": [
        1680.0,
        875.969970703125,
        105.3599853515625
      ],
      "bbox_max": [
        1690.0,
        882.9279174804688,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578262567520142
      ],
      "plane_d": 381.827880859375,
      "bbox_min": [
        1680.0,
        875.969970703125,
        105.3599853515625
      ],
      "bbox_max": [
        1682.550048828125,
        882.9279174804688,
        106.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1680.0,
        882.5,
        100.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1622.40234375,
      "bbox_min": [
        1680.0,
        882.5,
        100.0
      ],
      "bbox_max": [
        1682.550048828125,
        884.030029296875,
        106.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578262567520142
      ],
      "plane_d": 381.827880859375,
      "bbox_min": [
        1680.0,
        882.5,
        105.3599853515625
      ],
      "bbox_max": [
        1682.550048828125,
        884.030029296875,
        106.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1965.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1655.0,
        810.0,
        190.0
      ],
      "bbox_max": [
        1680.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1655.0,
        840.0,
        190.0
      ],
      "bbox_max": [
        1680.0,
        840.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1917.93896484375,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1660.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1917.93896484375,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        810.0,
        165.0
      ],
      "bbox_max": [
        1680.0,
        810.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1665.0,
        1910.0,
        165.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1917.93896484375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0517671802954283e-06,
        0.0
      ],
      "plane_d": -1665.005859375,
      "bbox_min": [
        1665.0,
        1910.0,
        165.0
      ],
      "bbox_max": [
        1665.0,
        1917.93896484375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1660.0,
        810.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1917.5001220703125,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1660.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        1917.5001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        810.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1660.0,
        878.75,
        140.0
      ],
      "bbox_max": [
        1675.0,
        1917.5001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        1668.75,
        878.75,
        140.0
      ],
      "bbox_max": [
        1671.25,
        881.25,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1668.75,
        880.0,
        140.0
      ],
      "bbox_max": [
        1671.25,
        881.25,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0517671802954283e-06,
        0.0
      ],
      "plane_d": -1665.005859375,
      "bbox_min": [
        1660.0,
        1910.0,
        164.42747497558594
      ],
      "bbox_max": [
        1665.0,
        1917.5001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": 1152.219970703125,
      "bbox_min": [
        1660.0,
        1910.0,
        164.42747497558594
      ],
      "bbox_max": [
        1665.0,
        1910.916015625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        810.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.0517671802954283e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1555.0050048828125,
      "bbox_min": [
        1660.0,
        878.25,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1667.5,
        878.25,
        138.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        1668.25,
        878.25,
        138.0
      ],
      "bbox_max": [
        1671.75,
        881.75,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1668.25,
        881.25,
        138.0
      ],
      "bbox_max": [
        1671.75,
        881.75,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1660.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1660.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1660.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.0517671802954283e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1555.0050048828125,
      "bbox_min": [
        1660.0,
        877.5,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        1667.5,
        877.5,
        135.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1667.5,
        881.25,
        135.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1668.125,
        881.25,
        135.0
      ],
      "bbox_max": [
        1671.875,
        881.875,
        137.5000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1668.125,
        881.875,
        137.5
      ],
      "bbox_max": [
        1672.0,
        882.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1668.0,
        881.875,
        137.5
      ],
      "bbox_max": [
        1668.25,
        882.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1660.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1660.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.0,
      "bbox_min": [
        1660.0,
        860.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        1660.0,
        860.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": -664.4215698242188,
      "bbox_min": [
        1660.0,
        863.272705078125,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574928641319275,
        0.0
      ],
      "plane_d": 96.06494140625,
      "bbox_min": [
        1660.0,
        867.5,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        0.9578262567520142
      ],
      "plane_d": 381.827880859375,
      "bbox_min": [
        1663.800048828125,
        867.5,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1622.40234375,
      "bbox_min": [
        1675.85009765625,
        884.030029296875,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        105.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574928641319275,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -1893.3870849609375,
      "bbox_min": [
        1675.85009765625,
        886.25,
        100.0
      ],
      "bbox_max": [
        1676.300048828125,
        887.0,
        104.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2873478829860687,
        0.9578262567520142
      ],
      "plane_d": -350.923583984375,
      "bbox_min": [
        1663.800048828125,
        867.5,
        104.11502838134766
      ],
      "bbox_max": [
        1676.300048828125,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -828.2591552734375,
      "bbox_min": [
        1668.75,
        878.75,
        104.11502838134766
      ],
      "bbox_max": [
        1676.300048828125,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1645.6041259765625,
      "bbox_min": [
        1668.75,
        878.75,
        105.0
      ],
      "bbox_max": [
        1670.0,
        881.25,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574928641319275,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -1893.3870849609375,
      "bbox_min": [
        1675.85009765625,
        886.25,
        104.11502838134766
      ],
      "bbox_max": [
        1676.300048828125,
        887.0,
        104.4749984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": 970.7249755859375,
      "bbox_min": [
        1663.800048828125,
        886.25,
        100.0
      ],
      "bbox_max": [
        1664.25,
        887.0,
        104.4749984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -828.2591552734375,
      "bbox_min": [
        1666.25,
        860.0,
        110.0
      ],
      "bbox_max": [
        1673.75,
        883.75,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1645.6041259765625,
      "bbox_min": [
        1666.25,
        860.0,
        110.0
      ],
      "bbox_max": [
        1671.845458984375,
        883.75,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": -664.4215698242188,
      "bbox_min": [
        1668.463134765625,
        860.0,
        110.0
      ],
      "bbox_max": [
        1671.845458984375,
        863.272705078125,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": -664.4215698242188,
      "bbox_min": [
        1668.254638671875,
        862.021484375,
        110.0
      ],
      "bbox_max": [
        1668.7498779296875,
        863.272705078125,
        111.14696502685547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.986393928527832,
        0.16439899802207947,
        0.0
      ],
      "plane_d": -1796.519287109375,
      "bbox_min": [
        1664.25,
        887.0,
        100.0
      ],
      "bbox_max": [
        1675.85009765625,
        900.0,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863939881324768,
        0.16439899802207947,
        0.0
      ],
      "plane_d": 1498.13525390625,
      "bbox_min": [
        1664.25,
        887.0,
        100.0
      ],
      "bbox_max": [
        1671.300048828125,
        900.0,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1668.800048828125,
        900.0,
        100.0
      ],
      "bbox_max": [
        1671.300048828125,
        900.0,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": 970.7249755859375,
      "bbox_min": [
        1664.25,
        887.0,
        100.0
      ],
      "bbox_max": [
        1667.550048828125,
        892.5,
        106.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574928641319275,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -1893.3870849609375,
      "bbox_min": [
        1672.550048828125,
        887.0,
        100.0
      ],
      "bbox_max": [
        1675.85009765625,
        892.5,
        106.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        1665.0,
        875.0,
        120.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1665.0,
        875.0,
        120.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1645.6041259765625,
      "bbox_min": [
        1665.0,
        875.0,
        120.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -828.2591552734375,
      "bbox_min": [
        1665.0,
        880.0,
        120.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1668.75,
        880.0,
        130.0
      ],
      "bbox_max": [
        1671.25,
        881.25,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        1910.916015625,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        1910.916015625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1655.0,
        840.0,
        165.0
      ],
      "bbox_max": [
        1660.0,
        840.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1655.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        1910.916015625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1655.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        963.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        1910.916015625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": 1152.219970703125,
      "bbox_min": [
        1655.0,
        1910.0,
        164.42747497558594
      ],
      "bbox_max": [
        1660.0,
        1910.916015625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        1555.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1655.0,
        1030.0,
        135.0
      ],
      "bbox_max": [
        1660.0,
        1555.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1655.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1657.0,
        1150.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0517671802954283e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1555.0050048828125,
      "bbox_min": [
        1655.0,
        1150.0,
        135.0
      ],
      "bbox_max": [
        1660.0,
        1555.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1655.0,
        1150.0,
        135.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0517671802954283e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1555.0050048828125,
      "bbox_min": [
        1655.5,
        1555.0,
        135.0
      ],
      "bbox_max": [
        1660.0,
        1555.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1655.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574928641319275,
        0.0
      ],
      "plane_d": 96.06494140625,
      "bbox_min": [
        1655.0,
        882.5,
        100.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1655.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1655.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1655.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: win1",
      "entity_class": "CSlidingDoor",
      "piece_name": "win1",
      "offset": 902,
      "centroid": [
        1696.199951171875,
        1522.5,
        126.5
      ],
      "bbox_min": [
        1696.199951171875,
        1505.0,
        123.0
      ],
      "bbox_max": [
        1696.199951171875,
        1540.0,
        130.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 35.0,
        "height_z": 7.0,
        "door_width": 35.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z"
      },
      "vertices": [
        [
          1696.199951171875,
          1517.5,
          123.0
        ],
        [
          1696.199951171875,
          1507.5,
          123.0
        ],
        [
          1696.199951171875,
          1505.0,
          125.0
        ],
        [
          1696.199951171875,
          1505.0,
          128.0
        ],
        [
          1696.199951171875,
          1507.5,
          130.0
        ],
        [
          1696.199951171875,
          1517.5,
          130.0
        ],
        [
          1696.199951171875,
          1520.0,
          128.0
        ],
        [
          1696.199951171875,
          1520.0,
          125.0
        ],
        [
          1696.199951171875,
          1527.5,
          123.0
        ],
        [
          1696.199951171875,
          1525.0,
          125.0
        ],
        [
          1696.199951171875,
          1525.0,
          128.0
        ],
        [
          1696.199951171875,
          1527.5,
          130.0
        ],
        [
          1696.199951171875,
          1537.5,
          130.0
        ],
        [
          1696.199951171875,
          1540.0,
          128.0
        ],
        [
          1696.199951171875,
          1540.0,
          125.0
        ],
        [
          1696.199951171875,
          1537.5,
          123.0
        ]
      ],
      "authentic_texture": "airwindow1-t"
    }
  ],
  "tutorial_messages": []
}